var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// ../../react-shim.js
import React from "react";

// src/default-theme/components/index.ts
var components_exports = {};
__export(components_exports, {
  Alert: () => Alert,
  Button: () => Button,
  Checkbox: () => Checkbox,
  Container: () => Container,
  Divider: () => Divider,
  Drawer: () => Drawer,
  Form: () => Form,
  FormError: () => FormError,
  FormLabel: () => FormLabel,
  Heading: () => Heading,
  Icon: () => Icon,
  Input: () => Input,
  Link: () => Link,
  Menu: () => Menu,
  Radio: () => Radio,
  Skeleton: () => Skeleton,
  Spinner: () => Spinner,
  Tabs: () => Tabs,
  Tag: () => Tag,
  Text: () => Text
});

// src/default-theme/components/Button.ts
var getHoverAndFocusStyles = (styles7) => ({
  _hover: styles7,
  _focus: styles7
});
var Button = {
  baseStyle: {
    cursor: "pointer",
    textStyle: "action"
  },
  sizes: {
    sm: {
      h: [4, 4, 4.5],
      px: 1,
      borderRadius: "sm"
    },
    md: {
      py: 2,
      px: [3, 3, 5],
      borderRadius: "md",
      minWidth: 18
    },
    lg: {
      py: 2,
      px: [3, 3, 5],
      borderRadius: "md",
      minWidth: 18
    }
  },
  variants: {
    primary: {
      color: "text.primaryInverse",
      bg: "action.primary1",
      boxShadow: "mediumPrimary",
      ...getHoverAndFocusStyles({
        bg: "action.hover"
      }),
      _disabled: {
        cursor: "default"
      }
    },
    secondary: {
      color: "text.primary",
      bg: "action.tertiary",
      ...getHoverAndFocusStyles({
        bg: "action.tertiaryPress"
      }),
      _disabled: {
        cursor: "default",
        bg: "action.tertiary"
      }
    },
    surface: {
      color: "text.primary",
      bg: "action.surface"
    },
    surfaceInverse: {
      color: "text.primaryInverse",
      bg: "action.surfaceInverse"
    },
    ghost: {
      color: "text.accent",
      ...getHoverAndFocusStyles({
        color: "elevation.mediumPrimary"
      })
    },
    primaryInverse: {
      color: "text.primary",
      bg: "action.primary1Inverse",
      boxShadow: "mediumPrimaryInverse"
    },
    primary2: {
      color: "text.primaryInverse",
      bg: "action.primary2",
      ...getHoverAndFocusStyles({
        bg: "action.primary2Inverse"
      })
    },
    attention: {
      color: "text.primaryInverse",
      bg: "action.attention",
      ...getHoverAndFocusStyles({
        bg: "elevation.mediumAttention"
      })
    },
    success: {
      color: "text.primaryInverse",
      bgColor: "action.success",
      ...getHoverAndFocusStyles({
        bg: "elevation.mediumSuccess"
      })
    },
    disabled: {
      color: "text.disabled",
      bg: "action.disabled",
      cursor: "not-allowed",
      boxShadow: "none"
    }
  },
  defaultProps: {
    size: "md",
    variant: "primary"
  }
};

// src/default-theme/components/Container.ts
var spacingStyles = {
  xs: {
    mb: [3, 3, 5]
  },
  sm: {
    mb: [5, 5, 10]
  },
  md: {
    mb: [10, 10, 20]
  },
  none: {}
};
var Container = {
  baseStyle: ({ spacing }) => ({
    maxW: ["480px", "604px", "1208px"],
    w: "100%",
    mx: "auto",
    ...spacingStyles[spacing === "default" ? "md" : spacing]
  }),
  variants: {
    base: {
      px: [3, 5, 0]
    }
  },
  defaultProps: {
    spacing: "none"
  }
};

// src/default-theme/components/Drawer.ts
import { drawerAnatomy as parts } from "@chakra-ui/anatomy";
function getSize(value) {
  if (value === "full") {
    return {
      dialog: { maxW: "100vw", h: "100vh" }
    };
  }
  return {
    dialog: { maxW: value }
  };
}
var baseStyleOverlay = {
  bg: "base.overlay",
  zIndex: "overlay"
};
var baseStyleDialogContainer = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
};
var baseStyleDialog = (props) => {
  const { isFullHeight, rounded, borderRadius = "xl", position } = props;
  return {
    ...isFullHeight && { height: "100vh" },
    ...rounded && {
      overflow: "hidden",
      ...position === "left" && {
        borderRightRadius: borderRadius
      },
      ...position === "right" && {
        borderLeftRadius: borderRadius
      },
      ...position === "top" && {
        borderBottomRadius: borderRadius
      },
      ...position === "bottom" && {
        borderTopRadius: borderRadius
      }
    },
    zIndex: "modal",
    bg: "base.primary",
    color: "inherit"
  };
};
var baseStyleHeader = {
  p: 3
};
var baseStyleCloseButton = {
  position: "absolute",
  top: 2,
  insetEnd: 3,
  marginLeft: "auto"
};
var baseStyleBody = {
  p: 3,
  flex: 1,
  overflow: "auto"
};
var baseStyleFooter = {
  p: 3
};
var baseStyle = (props) => ({
  overlay: baseStyleOverlay,
  dialogContainer: baseStyleDialogContainer,
  dialog: baseStyleDialog(props),
  header: baseStyleHeader,
  closeButton: baseStyleCloseButton,
  body: baseStyleBody,
  footer: baseStyleFooter
});
var sizes = {
  xs: getSize("25%"),
  sm: getSize("35%"),
  md: getSize("50%"),
  lg: getSize("75%"),
  xl: getSize("90%"),
  full: getSize("full")
};
var variants = {
  mobileMd: {
    dialog: {
      height: "55%",
      borderTopRadius: "lg"
    }
  },
  mobileXl: {
    dialog: {
      height: "98%",
      borderTopRadius: "lg"
    }
  }
};
var defaultProps = {
  size: "md"
};
var Drawer = {
  parts: parts.keys,
  baseStyle,
  sizes,
  variants,
  defaultProps
};

// src/default-theme/components/Form.ts
import { formAnatomy as parts2 } from "@chakra-ui/anatomy";
var floatingLabelStyles = {
  initial: {
    top: ["18px", "18px", 3],
    left: 0,
    zIndex: 2,
    position: "absolute",
    backgroundColor: "transparent",
    pointerEvents: "none",
    color: "text.primary"
  },
  floating: {
    transform: "translateY(-100%)",
    color: "text.secondary",
    textStyle: "caption"
  },
  offsetStart: {
    left: 4.5
  }
};
var baseStyle2 = {
  container: {
    width: "100%",
    position: "relative"
  },
  helperText: {
    textStyle: "caption",
    color: "text.secondary",
    mt: 0.5
  }
};
var Form = {
  parts: parts2.keys,
  baseStyle: baseStyle2,
  variants: {
    floating: {
      container: {
        pt: [0.25, 0.25, 2],
        _focusWithin: {
          ".chakra-form__label": { ...floatingLabelStyles.floating }
        },
        ".chakra-input__group": { position: "static" },
        "input:not(:placeholder-shown) + .chakra-form__label, .chakra-select__wrapper + .chakra-form__label, .chakra-react-select--has-value + .chakra-form__label": { ...floatingLabelStyles.floating },
        ".chakra-form__label": { ...floatingLabelStyles.initial },
        ".chakra-input__left-element ~ .chakra-form__label, .chakra-react-select--has-icon-left ~ .chakra-form__label": { ...floatingLabelStyles.offsetStart }
      }
    }
  }
};

// src/default-theme/components/FormLabel.ts
var FormLabel = {
  baseStyle: {
    marginEnd: 3,
    mb: 2,
    transition: "color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    opacity: 1,
    _disabled: {
      opacity: 0.4
    },
    textStyle: "body",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
};

// src/default-theme/components/FormError.ts
import { formErrorAnatomy as parts3 } from "@chakra-ui/anatomy";
var baseStyleText = {
  color: "action.error",
  mt: 0.5,
  textStyle: "caption"
};
var baseStyleIcon = {
  marginEnd: 0.5,
  color: "action.error"
};
var baseStyle3 = {
  text: baseStyleText,
  icon: baseStyleIcon
};
var FormError = {
  parts: parts3.keys,
  baseStyle: baseStyle3
};

// src/default-theme/components/Icon.ts
var Icon = {
  baseStyle: {
    color: "text.primary",
    display: "inline"
  },
  sizes: {
    sm: {
      w: 2,
      h: 2
    },
    md: {
      w: 3,
      h: 3
    },
    lg: {
      w: 6,
      h: 6
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/default-theme/components/Input.ts
import { inputAnatomy as parts4 } from "@chakra-ui/anatomy";

// src/default-theme/foundations/index.ts
var foundations_exports = {};
__export(foundations_exports, {
  breakpoints: () => breakpoints,
  colors: () => colors,
  fontSizes: () => fontSizes,
  fontWeights: () => fontWeights,
  fonts: () => fonts,
  lineHeights: () => lineHeights,
  radii: () => radii,
  shadows: () => shadows,
  sizes: () => sizes2,
  space: () => space,
  textStyles: () => textStyles,
  zIndices: () => zIndices
});

// src/default-theme/foundations/breakpoints.ts
var breakpoints = {
  base: "0em",
  tablet: "1024px",
  desktop: "1366px",
  desktopXL: "1600px"
};

// src/default-theme/foundations/space.ts
var space = {
  0: "0px",
  0.25: "2px",
  0.5: "4px",
  0.75: "6px",
  1: "8px",
  1.25: "10px",
  1.5: "12px",
  1.75: "14px",
  2: "16px",
  2.5: "20px",
  3: "24px",
  3.5: "28px",
  4: "32px",
  4.5: "36px",
  5: "40px",
  5.5: "44px",
  6: "48px",
  6.5: "52px",
  7: "56px",
  8: "64px",
  10: "80px",
  12: "96px",
  20: "160px"
};

// src/default-theme/foundations/colors.ts
var colors = {
  base: {
    primary: "hsla(0, 0%, 100%, 1)",
    secondary: "hsla(0, 0%, 96%, 1)",
    overlay: "hsla(0, 0%, 0%, 0.35)",
    overlayInverse: "hsla(0, 0%, 0%, 0.9)",
    accent: "hsla(1, 78%, 64%, 1)",
    primaryInverse: "hsla(0, 0%, 3%, 1)",
    secondaryInverse: "hsla(0, 0%, 16%, 1)",
    surface: "hsla(0, 0%, 100%, 0.7)",
    surfaceInverse: "hsla(0, 0%, 12%, 0.7)",
    surfacePrimary: "rgba(255, 255, 255, 0.7)",
    surfaceSecondary: "rgba(242, 242, 242, 0.5)",
    accentGradient: "linear-gradient(90deg, hsla(1, 100%, 75%, 1), hsla(1, 80%, 59%, 1))",
    transparent: "hsla(0, 0%, 0%, 0)",
    dashboard: "hsla(44, 50%, 94%, 1)",
    gradient: "linear-gradient(91.25deg, #FFFBEF 9.36%, #FDEFEF 68.08%)",
    gradient2: "linear-gradient(91.25deg, hsla(44, 100%, 97%, 1), hsla(0, 78%, 96%, 1))",
    logo: "hsla(230, 80%, 52%, 1)",
    autofill: "transparent"
  },
  action: {
    primary1: "hsla(1, 78%, 64%, 1)",
    primary1Inverse: "hsla(0, 0%, 100%, 1)",
    primary2: "hsla(220, 96%, 45%, 1)",
    primary2Inverse: "hsla(220, 96%, 60%, 1)",
    primary1Press: "hsla(1, 65%, 60%, 1)",
    secondary: "hsla(0, 0%, 100%, 1)",
    tertiary: "hsla(0, 0%, 0%, 0.04)",
    tertiaryInverse: "hsla(0, 0%, 94%, 0.6)",
    tertiaryPress: "hsla(0, 0%, 0%, 0.08)",
    surface: "hsla(0, 0%, 100%, 0.6)",
    surfaceInverse: "hsla(0, 0%, 100%, 0.3)",
    attention: "hsla(31, 95%, 56%, 1)",
    success: "hsla(130, 53%, 58%, 1)",
    disabled: "hsla(0, 0%, 0%, 0.03)",
    input: "hsla(216, 14%, 93%, 1)",
    error: "hsla(349, 92%, 48%, 1)",
    hover: "hsla(1, 78%, 54%, 1)",
    tinted: "hsla(1, 78%, 64%, 1)"
  },
  elevation: {
    low: "hsla(0, 0%, 0%, 0.09)",
    medium: "hsla(0, 0%, 0%, 0.12)",
    high: "hsla(0, 0%, 0%, 0.2)",
    mediumPrimary: "hsla(1, 78%, 64%, 0.3)",
    mediumPrimary2: "hsla(234, 78%, 64%, 0.3)",
    mediumAttention: "hsla(31, 78%, 64%, 0.3)",
    mediumSuccess: "hsla(130, 78%, 64%, 0.3)"
  },
  text: {
    primary: "hsla(207, 14%, 18%, 1)",
    primaryInverse: "hsla(0, 0%, 100%, 1)",
    primaryContrast: "hsla(207, 14%, 18%, 1)",
    primaryContrastInverse: "hsla(0, 0%, 100%, 1)",
    secondary: "hsla(190, 3%, 34%, 0.6)",
    secondaryInverse: "hsla(207, 100%, 100%, 0.7)",
    secondaryContrast: "hsla(190, 3%, 34%, 0.6)",
    secondaryContrastInverse: "hsla(207, 100%, 100%, 0.7)",
    tertiary: "hsla(207, 14%, 9%, 0.22)",
    tertiaryInverse: "hsla(0, 0%, 100%, 0.4)",
    tertiaryContrast: "hsla(207, 14%, 9%, 0.22)",
    tertiaryContrastInverse: "hsla(0, 0%, 100%, 0.4)",
    placeholder: "hsla(190, 3%, 75%, 0.6)",
    accent: "hsla(1, 78%, 64%, 1)",
    accentInverse: "hsla(1, 78%, 64%, 1)",
    link: "hsla(234, 100%, 50%, 1)",
    linkInverse: "hsla(234, 100%, 50%, 1)",
    disabled: "hsla(190, 5%, 74%, 0.4)",
    disabledInverse: "hsla(190, 5%, 74%, 0.4)",
    disabledContrast: "hsla(190, 5%, 74%, 0.4)",
    disabledContrastInverse: "hsla(190, 5%, 74%, 0.4)"
  },
  line: {
    primary: "hsla(1, 78%, 64%, 1)",
    secondary: "hsla(207, 14%, 30%, 0.1)",
    primaryInverse: "hsla(0, 0%, 100%, 1)",
    secondaryInverse: "hsla(0, 0%, 100%, 0.3)"
  },
  brand: {
    cultured: "hsla(190, 21%, 95%, 1)",
    lavendar: "hsla(0, 78%, 96%, 1)",
    charcoal: "hsla(207, 14%, 30%, 1)",
    honey: "hsla(42, 100%, 50%, 1)"
  },
  tint: {
    success: "hsla(130, 53%, 58%, 1)",
    attention: "hsla(31, 95%, 56%, 1)"
  }
};

// src/default-theme/foundations/fonts.ts
var fonts = {
  body: `'Inter', sans-serif`,
  heading: `'Inter', sans-serif`
};

// src/default-theme/foundations/sizes.ts
var sizes2 = {
  0.5: "4px",
  1: "8px",
  1.5: "12px",
  2: "16px",
  2.5: "20px",
  3: "24px",
  3.5: "28px",
  4: "32px",
  4.5: "36px",
  5: "40px",
  5.5: "44px",
  6: "48px",
  6.5: "52px",
  7: "56px",
  8: "64px",
  8.5: "68px",
  10: "80px",
  12: "96px",
  17.5: "140px",
  18: "144px",
  25: "200px",
  26: "208px",
  32.5: "260px",
  42: "336px"
};

// src/default-theme/foundations/fontSizes.ts
var fontSizes = {
  11: "11px",
  13: "13px",
  15: "15px",
  17: "17px",
  20: "20px",
  22: "22px",
  28: "28px",
  35: "35px",
  40: "40px",
  45: "45px",
  50: "50px",
  64: "64px",
  96: "96px",
  144: "142px",
  240: "240px"
};

// src/default-theme/foundations/fontWeights.ts
var fontWeights = {
  body: 400,
  heading: 600,
  bold: 600
};

// src/default-theme/foundations/lineHeights.ts
var lineHeights = {
  normal: "normal",
  inherit: "inherit",
  base: "140%",
  heading: "120%",
  2: "16px",
  3: "24px",
  5: "40px"
};

// src/default-theme/foundations/textStyles.ts
var textStyles = {
  display1: {
    fontSize: [45, 45, 64],
    lineHeight: "100%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  display2: {
    fontSize: [40, 40, 50],
    lineHeight: "100%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  title1: {
    fontSize: [28, 28, 35],
    lineHeight: "120%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  title2: {
    fontSize: [22, 22, 28],
    fontWeight: "heading",
    lineHeight: "120%",
    letterSpacing: "-0.02em"
  },
  title3: {
    fontSize: [17, 17, 20],
    fontWeight: "heading",
    lineHeight: "120%",
    letterSpacing: "0em"
  },
  title4: {
    fontSize: [13, 13, 17],
    lineHeight: "120%",
    fontWeight: "heading",
    letterSpacing: "0.04em",
    textTransform: "uppercase"
  },
  body: {
    fontSize: [17, 17, 20],
    lineHeight: "140%"
  },
  caption: {
    fontSize: [13, 13, 17],
    lineHeight: "140%"
  },
  captionSmall: {
    fontSize: [11, 11, 15],
    lineHeight: "140%"
  },
  action: {
    fontSize: [17, 17, 20],
    lineHeight: "120%",
    fontWeight: "bold"
  }
};

// src/default-theme/foundations/radii.ts
var radii = {
  none: "0",
  base: "10px",
  xs: "4px",
  sm: "10px",
  md: "16px",
  lg: "22px",
  xl: "28px"
};

// src/default-theme/foundations/zIndices.ts
var zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 20,
  sticky: 30,
  banner: 40,
  overlay: 50,
  modal: 60,
  popover: 70,
  skipLink: 80,
  toast: 90,
  tooltip: 100
};

// src/default-theme/foundations/shadows.ts
var shadows = {
  low: "0px 1px 10px 0px rgba(0, 0, 0, 0.09)",
  medium: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
  mediumPrimary: "0px 4px 12px 0px rgba(235, 94, 91, 0.3)",
  mediumPrimaryInverse: "0px 4px 12px rgba(0, 0, 0, 0.12)",
  mediumPrimary2: "0px 4px 12px 0px rgba(91, 105, 235, 0.3)",
  mediumSuccess: "0px 4px 12px 0px rgba(91, 235, 115, 0.3)",
  mediumAttention: "0px 4px 12px 0px rgba(235, 165, 91, 0.3)",
  high: "0px 10px 40px rgba(0, 0, 0, 0.2)",
  box: {
    base: "0px 0px 0px 1px hsla(207, 14%, 30%, 0.1)",
    selected: "0px 0px 0px 2px hsla(1, 78%, 64%, 1)"
  }
};

// src/default-theme/components/Input.ts
var baseStyle4 = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    color: "text.primary",
    ".chakra-input__left-element ~ &": {
      pl: 4.5
    },
    ".chakra-input__right-element ~ &": {
      pr: 4.5
    }
  },
  element: {
    boxSizing: "content-box",
    width: 3
  }
};
var variantFlushed = {
  field: {
    width: "100%",
    borderBottom: "1px solid",
    borderColor: "line.secondary",
    borderRadius: 0,
    px: 0,
    bg: "transparent",
    _readOnly: {
      boxShadow: "none !important",
      userSelect: "all"
    },
    _focus: {
      borderColor: "text.link"
    },
    _invalid: {
      borderColor: "action.error"
    },
    _placeholder: {
      transition: "all 0.3s"
    }
  },
  addon: {
    borderBottom: "1px solid",
    borderColor: "inherit",
    borderRadius: 0,
    px: 0,
    bg: "transparent"
  }
};
var sizes3 = {
  md: {
    field: {
      h: [7, 7, 5.5],
      ...textStyles.body
    },
    addon: {
      h: [7, 7, 5.5],
      ...textStyles.body
    }
  }
};
var Input = {
  parts: parts4.keys,
  baseStyle: baseStyle4,
  sizes: sizes3,
  variants: {
    flushed: variantFlushed
  },
  defaultProps: {
    size: "md",
    variant: "flushed"
  }
};

// src/default-theme/components/Radio.ts
var Radio = {
  baseStyle: {
    label: {
      userSelect: "none",
      _disabled: { opacity: 0.4 }
    },
    control: {
      w: "100%",
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      color: "base.secondary",
      bg: "text.placeholder",
      borderRadius: "50%",
      _checked: {
        bg: "base.accent",
        _before: {
          content: '""',
          display: "inline-block",
          pos: "relative",
          w: 1,
          h: 1,
          borderRadius: "50%",
          bg: "base.primary"
        }
      },
      _disabled: {
        _hover: {
          cursor: "not-allowed",
          borderColor: "base.secondary"
        }
      }
    }
  },
  sizes: {
    md: {
      control: { w: 3, h: 3 }
    }
  },
  defaultProps: {
    size: "md",
    colorScheme: "base.checkbox"
  }
};

// src/default-theme/components/Skeleton.ts
import { keyframes } from "@emotion/react";
var fade = () => keyframes({
  from: { opacity: 1 },
  to: { opacity: 0.4 }
});
var Skeleton = {
  sizes: {
    sm: { w: [4.5, 8.5], h: [3, 3.5] },
    md: { w: [17.5, 32.5], h: [3, 3.5] },
    lg: { w: [26, 42], h: [4.5, 5.5] }
  },
  baseStyle: {
    borderRadius: "xs",
    borderColor: "base.secondary",
    background: "base.secondary",
    animation: `0.8s linear infinite alternate ${fade()}`
  },
  defaultProps: {
    size: "md"
  }
};

// src/default-theme/components/Spinner.ts
var Spinner = {
  sizes: {
    md: { w: 2.5, h: 2.5 }
  },
  defaultProps: {
    size: "md"
  }
};

// src/default-theme/components/Heading.ts
var Heading = {
  baseStyle: {
    textStyle: "display1",
    color: "text.primary"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/default-theme/components/Text.ts
var Text = {
  variants: {
    base: {
      textStyle: "body",
      color: "text.primary"
    },
    unstyled: {}
  },
  defaultProps: {
    variant: "base"
  }
};

// src/default-theme/components/Checkbox.ts
var Checkbox = {
  baseStyle: {
    control: {
      outline: "none"
    },
    label: {
      userSelect: "none"
    }
  },
  sizes: {
    md: {
      icon: { h: "10px" },
      control: { w: 3, h: 3 }
    }
  },
  variants: {
    secondary: {
      icon: {
        color: "text.primaryInverse"
      },
      container: {
        w: "100%",
        flexDirection: "row-reverse",
        justifyContent: "space-between"
      },
      control: {
        border: "none",
        borderRadius: "sm",
        bg: "text.placeholder",
        _checked: {
          bg: "action.primary1",
          _hover: {
            bg: "action.primary1"
          }
        },
        _focus: {
          boxShadow: "none"
        }
      },
      label: {
        ...textStyles.caption,
        ml: 0,
        mr: 2
      }
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/default-theme/components/Tabs.ts
var Tabs = {
  parts: ["root", "tab", "tablist"],
  baseStyle: {
    tab: {
      h: ["36px", 7],
      color: "text.primary",
      border: "1px solid",
      borderColor: "line.secondary",
      borderRadius: "xl",
      px: 2,
      py: [1, 2],
      textStyle: "action",
      _hover: {
        bg: "base.surfaceSecondary",
        color: "text.primary",
        cursor: "pointer",
        borderColor: "line.secondary"
      },
      _selected: {
        color: "text.primaryInverse",
        bg: "base.primaryInverse",
        borderColor: "base.primaryInverse"
      }
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/default-theme/components/Alert.ts
var parts5 = ["container", "icon", "title", "description", "spinner"];
var baseStyle5 = {
  container: {
    p: 3,
    display: "flex"
  },
  title: {
    fontWeight: "bold",
    textStyle: "title2",
    mb: 1
  },
  description: {
    textStyle: "body"
  },
  icon: {
    flexShrink: 0,
    marginEnd: 1,
    w: "20px",
    h: "20px"
  }
};
var variantLeftAccent = () => {
  return {
    container: {
      borderColor: "base.overlay",
      borderWidth: "1px",
      borderRadius: "md",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    title: {
      color: "text.secondary"
    },
    icon: {},
    description: {
      color: "text.secondary"
    }
  };
};
var variantTopAccent = () => {
  return {
    container: {
      flexDirection: "column"
    },
    icon: {},
    description: {}
  };
};
var variants2 = {
  "left-accent": variantLeftAccent,
  "top-accent": variantTopAccent
};
var defaultProps2 = {
  variant: "left-accent"
};
var Alert = {
  parts: parts5,
  baseStyle: baseStyle5,
  variants: variants2,
  defaultProps: defaultProps2
};

// src/default-theme/components/Link.ts
var Link = {
  baseStyle: {
    color: "text.primary"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/default-theme/components/Tag.ts
var Tag = {
  parts: ["container"],
  baseStyle: {
    container: {
      px: 1,
      py: 0.5,
      textStyle: ["title3", "title3", "title1"],
      textTransform: "uppercase",
      borderRadius: "xs"
    }
  },
  variants: {
    base: {
      container: {
        color: "text.primary",
        px: 0
      }
    },
    primary: {
      container: {
        backgroundColor: "base.primaryInverse",
        color: "text.primaryInverse"
      }
    },
    accent: {
      container: {
        backgroundColor: "base.accent",
        color: "text.primaryInverse"
      }
    }
  },
  defaultProps: {
    variant: "base"
  }
};

// src/default-theme/components/Divider.ts
var Divider = {
  baseStyle: {
    borderWidth: ["1px", "1px", "2px"],
    borderColor: "line.secondary",
    borderStyle: "solid"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/default-theme/components/Menu.ts
import { theme } from "@chakra-ui/react";
var Menu = theme.components.Menu;

// src/default-theme/styles.ts
var styles_exports = {};
__export(styles_exports, {
  styles: () => styles
});
var styles = {
  global: {
    body: {
      fontFamily: "body"
    },
    "html, body": {
      background: "base.primary"
    },
    em: {
      fontStyle: "italic"
    },
    mark: {
      color: "text.link",
      fontStyle: "normal",
      backgroundColor: "unset"
    },
    a: {
      color: "text.link"
    }
  }
};

// src/default-theme/index.ts
var theme2 = {
  config: {
    initialColorMode: "light"
  },
  direction: "ltr",
  borders: {},
  letterSpacings: {},
  transition: {
    property: {},
    easing: {},
    duration: {}
  },
  components: components_exports,
  ...styles_exports,
  ...foundations_exports
};

// src/syt/index.ts
import { extendTheme } from "@chakra-ui/react";

// src/utils/clearFromDefaultVars.ts
var clearFromDefaultVars_default = (theme7) => {
  delete theme7?.breakpoints?.sm;
  delete theme7?.breakpoints?.md;
  delete theme7?.breakpoints?.lg;
  delete theme7?.breakpoints?.xl;
  delete theme7?.breakpoints?.["2xl"];
  delete theme7?.components?.Heading?.baseStyle?.fontWeight;
  return theme7;
};

// src/syt/styles.ts
var styles2 = {
  global: {
    body: {
      fontFamily: "'Inter Display', sans-serif"
    },
    "html, body": {
      background: "base.white"
    },
    a: {
      color: "base.blue"
    }
  }
};

// src/syt/foundations/index.ts
var foundations_exports2 = {};
__export(foundations_exports2, {
  breakpoints: () => breakpoints2,
  colors: () => colors2,
  fontSizes: () => fontSizes2,
  fontWeights: () => fontWeights2,
  fonts: () => fonts2,
  radii: () => radii2,
  shadows: () => shadows2,
  sizes: () => sizes4,
  space: () => sizes4,
  textStyles: () => textStyles2,
  zIndices: () => zIndices2
});

// src/syt/foundations/breakpoints.ts
var breakpoints2 = {
  base: "0px",
  tablet: "1024px",
  desktop: "1280px",
  desktopXL: "1600px"
};

// src/syt/foundations/colors.ts
var colorWhite = "hsla(0, 0%, 100%, 1)";
var colorWhiteSecondary = "hsla(0, 0%, 100%, 1)";
var colorBitterSweet = "hsla(359, 88%, 55%, 1)";
var colorBitterSweetSecondary = "hsla(359, 70%, 47%, 1)";
var colorBlue = "hsla(229, 99%, 48%, 1)";
var colorBlueSecondary = "hsla(229, 89%, 39%, 1)";
var colorGunmetal = "hsla(15, 6%, 14%, 1)";
var colorGunmetalSecondary = "hsla(0, 0%, 3%, 0.5)";
var colorHalfBlack = "hsla(0, 0%, 3%, 0.5)";
var colorHalfBlackAlt = "hsla(0, 0%, 3%, 0.3)";
var colorGrey = "hsla(0, 0%, 96%, 1)";
var colorGreyAlt = "hsla(0, 0%, 90%, 1)";
var colorSuccess = "hsla(130, 53%, 58%, 1)";
var colors2 = {
  base: {
    white: colorWhite,
    bitterSweet: colorBitterSweet,
    blue: colorBlue,
    gunmetal: colorGunmetal,
    halfBlack: colorHalfBlack,
    grey: colorGrey,
    success: colorSuccess
  },
  bg: {
    base: colorWhite,
    grey: colorGrey,
    baseInverse: colorGunmetal
  },
  line: {
    secondary: "hsla(207, 14%, 30%, 0.1)"
  },
  secondary: {
    white: colorWhiteSecondary,
    bitterSweet: colorBitterSweetSecondary,
    blue: colorBlueSecondary,
    gunmetal: colorGunmetalSecondary,
    halfBlack: colorHalfBlackAlt,
    grey: colorGreyAlt
  },
  text: {
    base: colorGunmetal,
    baseInverse: colorWhite,
    primary: colorBitterSweet,
    accent: colorBlue
  }
};

// src/syt/foundations/fonts.ts
var fonts2 = {
  body: `'Inter', sans-serif`,
  heading: `'Inter Display', sans-serif`
};

// src/syt/foundations/fontSizes.ts
var fontSizes2 = {
  12: "12px",
  14: "14px",
  16: "16px",
  17: "17px",
  20: "20px",
  26: "26px",
  36: "36px",
  56: "56px",
  92: "92px"
};

// src/syt/foundations/fontWeights.ts
var fontWeights2 = {
  thin: 100,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};

// src/syt/foundations/radii.ts
var radii2 = {
  none: "0",
  base: "14px",
  xs: "8px",
  sm: "14px",
  md: "20px",
  lg: "36px",
  xl: "56px"
};

// src/syt/foundations/shadows.ts
var shadows2 = {
  medium: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
  large: "0px 6px 14px 0px rgba(0, 0, 0, 0.10)"
};

// src/syt/foundations/sizes.ts
var sizes4 = {
  0.5: "4px",
  0.7: "10px",
  1: "14px",
  2: "20px",
  3: "36px",
  4: "56px",
  5: "92px",
  5.5: "132px",
  6: "148px",
  7: "204px",
  8: "316px",
  10: "596px"
};

// src/syt/foundations/textStyles.ts
var textStyles2 = {
  special: {
    fontSize: [52, 52, 92],
    lineHeight: "105%",
    fontWeight: ["black"],
    letterSpacing: ["-0.03em"],
    fontFamily: "heading"
  },
  special2: {
    fontSize: [26, 26, 36],
    lineHeight: "110%",
    fontWeight: ["extrabold", "extrabold", "black"],
    letterSpacing: ["-0.05em", "-0.05em", "-0.04em"],
    textTransform: ["uppercase"],
    fontFamily: "heading"
  },
  special3: {
    fontSize: [16, 16, 26],
    fontWeight: ["medium"],
    lineHeight: ["110%"],
    letterSpacing: ["-0.02em"],
    fontFamily: "heading"
  },
  H1: {
    fontSize: [42, 42, 72],
    lineHeight: ["105%"],
    fontWeight: ["bold"],
    letterSpacing: ["-0.04em"],
    fontFamily: "heading"
  },
  H2: {
    fontSize: [32, 32, 52],
    lineHeight: ["105%"],
    fontWeight: ["bold"],
    letterSpacing: ["-0.04em"],
    fontFamily: "heading"
  },
  H3: {
    fontSize: [16, 16, 26],
    fontWeight: ["medium"],
    lineHeight: ["110%"],
    letterSpacing: ["0.02em"],
    textTransform: ["uppercase"],
    fontFamily: "heading"
  },
  H4: {
    fontSize: [14, 14, 20],
    fontWeight: ["medium"],
    lineHeight: "110%",
    letterSpacing: ["0.02em"],
    textTransform: "uppercase",
    fontFamily: "heading"
  },
  H5: {
    fontSize: [14, 14, 17],
    fontWeight: ["normal", "normal", "bold"],
    lineHeight: ["110%"],
    letterSpacing: ["0.02em", "0.02em", "inherit"],
    fontFamily: "heading"
  },
  title1: {
    fontSize: [32, 32, 52],
    lineHeight: ["110%"],
    fontWeight: ["medium"],
    letterSpacing: ["-0.04em"],
    fontFamily: "heading"
  },
  title2: {
    fontSize: [24, 24, 36],
    lineHeight: ["110%"],
    fontWeight: ["medium"],
    letterSpacing: ["-0.04em"],
    fontFamily: "heading"
  },
  title3: {
    fontSize: [16, 16, 26],
    lineHeight: ["110%"],
    fontWeight: ["medium"],
    letterSpacing: ["-0.04em"],
    fontFamily: "heading"
  },
  body: {
    fontSize: [14, 14, 20],
    lineHeight: ["120%"],
    fontWeight: ["normal"],
    letterSpacing: ["0em"],
    fontFamily: "body"
  },
  bodySmall: {
    fontSize: [12, 12, 14],
    lineHeight: ["120%"],
    fontWeight: ["normal"],
    letterSpacing: ["0em"],
    fontFamily: "body"
  },
  caption: {
    fontSize: [14, 14, 20],
    lineHeight: ["110%"],
    fontWeight: ["medium"],
    letterSpacing: ["-0.03em"],
    fontFamily: "heading"
  },
  captionSmall: {
    fontSize: [12, 12, 14],
    lineHeight: ["110%"],
    fontWeight: ["normal"],
    letterSpacing: ["-0.03em"],
    fontFamily: "heading"
  }
};

// src/syt/foundations/zIndices.ts
var zIndices2 = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 20,
  sticky: 30,
  banner: 40,
  overlay: 50,
  modal: 60,
  popover: 70,
  skipLink: 80,
  toast: 90,
  tooltip: 100
};

// src/syt/components/index.ts
var components_exports2 = {};
__export(components_exports2, {
  Accordion: () => Accordion,
  Alert: () => Alert2,
  Button: () => Button2,
  Checkbox: () => Checkbox2,
  Container: () => Container2,
  Divider: () => Divider2,
  Drawer: () => Drawer2,
  Form: () => Form2,
  FormError: () => FormError2,
  FormLabel: () => FormLabel2,
  Heading: () => Heading2,
  Icon: () => Icon2,
  Input: () => Input2,
  Link: () => Link2,
  Menu: () => Menu2,
  Modal: () => Modal,
  Radio: () => Radio2,
  Skeleton: () => Skeleton2,
  Spinner: () => Spinner2,
  Switch: () => Switch,
  Table: () => Table,
  Tabs: () => Tabs2,
  Tag: () => Tag2,
  Text: () => Text2
});

// src/syt/components/Accordion.ts
var Accordion = {
  baseStyle: {
    container: {
      borderBottom: "1px solid",
      borderTop: "none",
      borderBottomColor: "base.grey",
      _first: {
        borderTop: "1px solid",
        borderTopColor: "base.grey"
      }
    },
    button: {
      "-webkit-tap-highlight-color": "transparent"
    },
    panel: {
      border: "none"
    }
  },
  sizes: {},
  variants: {
    withImage: {
      panel: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        h: "100%",
        p: [2, 2, 3]
      }
    }
  },
  defaultProps: {}
};

// src/syt/components/Alert.ts
var parts6 = ["container", "icon", "title", "description", "spinner"];
var baseStyle6 = {
  container: {
    p: 3,
    display: "flex"
  },
  title: {
    fontWeight: "bold",
    textStyle: "title2",
    mb: 1
  },
  description: {
    textStyle: "body"
  },
  icon: {
    flexShrink: 0,
    marginEnd: 1,
    w: "20px",
    h: "20px"
  }
};
var variantLeftAccent2 = () => {
  return {
    container: {
      borderColor: "base.overlay",
      borderWidth: "1px",
      borderRadius: "md",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    title: {
      color: "text.secondary"
    },
    icon: {},
    description: {
      color: "text.secondary"
    }
  };
};
var variantTopAccent2 = () => {
  return {
    container: {
      flexDirection: "column"
    },
    icon: {},
    description: {}
  };
};
var variants3 = {
  "left-accent": variantLeftAccent2,
  "top-accent": variantTopAccent2
};
var defaultProps3 = {
  variant: "left-accent"
};
var Alert2 = {
  parts: parts6,
  baseStyle: baseStyle6,
  variants: variants3,
  defaultProps: defaultProps3
};

// src/syt/components/Button.ts
var getHoverAndFocusStyles2 = (styles7) => ({
  _hover: styles7,
  _focus: styles7
});
var Button2 = {
  baseStyle: {
    cursor: "pointer",
    textStyle: "action",
    fontWeight: "normal",
    minW: "0px",
    fontFamily: "body"
  },
  sizes: {
    md: {
      py: ["7px", "7px", "9px"],
      px: ["14px", "14px", "20px"],
      borderRadius: "50px",
      fontSize: ["14px", "14px", "20px"],
      lineHeight: ["18px", "18px", "24px"],
      height: ["36px", "36px", "42px"],
      minW: "0px"
    },
    lg: {
      py: ["12px", "12px", "14px"],
      px: ["14px", "14px", "20px"],
      borderRadius: "50px",
      fontSize: ["14px", "14px", "20px"],
      lineHeight: ["18px", "18px", "24px"],
      height: ["42px", "42px", "52px"],
      minW: "0px"
    }
  },
  variants: {
    red: {
      color: "text.baseInverse",
      bgColor: "base.bitterSweet",
      ...getHoverAndFocusStyles2({
        bgColor: "secondary.bitterSweet"
      }),
      _active: {
        bgColor: "base.bitterSweet",
        color: "secondary.white"
      },
      _disabled: {
        cursor: "default"
      },
      svg: {
        color: "text.baseInverse",
        fill: "text.baseInverse"
      }
    },
    white: {
      color: "base.gunmetal",
      border: "1px solid",
      borderColor: "base.white",
      bgColor: "base.white",
      ...getHoverAndFocusStyles2({
        bgColor: "secondary.white",
        borderColor: "secondary.white"
      }),
      _active: {
        color: "secondary.gunmetal"
      },
      _disabled: {
        cursor: "default"
      }
    },
    grey: {
      color: "text.base",
      bgColor: "base.grey",
      ...getHoverAndFocusStyles2({
        borderColor: "secondary.grey"
      }),
      _active: {
        color: "secondary.grey"
      },
      _disabled: {
        cursor: "default"
      },
      _dark: {
        color: "text.baseInverse"
      }
    },
    stroked: {
      color: "text.base",
      border: "1px solid",
      borderColor: "base.gunmetal",
      bgColor: "transparent",
      ...getHoverAndFocusStyles2({
        borderColor: "secondary.gunmetal"
      }),
      _active: {
        color: "secondary.gunmetal"
      },
      _disabled: {
        cursor: "default"
      },
      svg: {
        color: "text.base",
        fill: "text.base"
      }
    },
    accent: {
      color: "text.baseInverse",
      border: "1px solid",
      borderColor: "base.blue",
      bgColor: "base.blue",
      ...getHoverAndFocusStyles2({
        bgColor: "secondary.blue",
        borderColor: "secondary.blue"
      }),
      _active: {
        color: "secondary.blue"
      },
      _disabled: {
        cursor: "default"
      }
    },
    black: {
      color: "text.baseInverse",
      border: "1px solid",
      borderColor: "base.gunmetal",
      bgColor: "base.gunmetal",
      _disabled: {
        cursor: "default"
      }
    },
    ghost: {
      color: "text.base",
      border: "none",
      bgColor: "transparent",
      ...getHoverAndFocusStyles2({
        bgColor: "transparent"
      }),
      _active: {
        color: "text.base"
      },
      _disabled: {
        cursor: "default"
      }
    },
    success: {
      color: "text.baseInverse",
      bgColor: "base.success",
      ...getHoverAndFocusStyles2({
        bgColor: "base.success"
      }),
      _active: {
        bgColor: "base.success",
        color: "secondary.white"
      },
      _disabled: {
        cursor: "default"
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "red"
  }
};

// src/syt/components/Checkbox.ts
var Checkbox2 = {
  baseStyle: {
    control: {
      outline: "none"
    },
    label: {
      userSelect: "none"
    }
  },
  sizes: {
    md: {
      icon: { h: "10px" },
      control: { w: 3, h: 3 }
    }
  },
  variants: {
    secondary: {
      icon: {
        color: "text.primaryInverse"
      },
      container: {
        w: "100%",
        flexDirection: "row-reverse",
        justifyContent: "space-between"
      },
      control: {
        border: "none",
        borderRadius: "sm",
        bg: "text.placeholder",
        _checked: {
          bg: "action.primary1",
          _hover: {
            bg: "action.primary1"
          }
        },
        _focus: {
          boxShadow: "none"
        }
      },
      label: {
        ...textStyles2.caption,
        ml: 0,
        mr: 2
      }
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/syt/components/Container.ts
var Container2 = {
  baseStyle: () => ({
    maxW: ["600px", "600px", "1600px"],
    w: "100%",
    mx: "auto",
    px: [2, 2, 2, 2]
  }),
  variants: {
    noPX: {
      px: 0
    },
    noMobilePX: {
      px: [0, 0, 2, 2]
    }
  }
};

// src/syt/components/Divider.ts
var Divider2 = {
  baseStyle: {
    borderWidth: ["1px", "1px", "2px"],
    borderColor: "line.secondary",
    borderStyle: "solid"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/syt/components/Drawer.ts
import { drawerAnatomy as parts7 } from "@chakra-ui/anatomy";
function getSize2(value) {
  if (value === "full") {
    return {
      dialog: { maxW: "100vw", h: "100vh" }
    };
  }
  return {
    dialog: { maxW: value }
  };
}
var baseStyleOverlay2 = {
  bg: "base.overlay",
  zIndex: "overlay"
};
var baseStyleDialogContainer2 = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
};
var baseStyleDialog2 = (props) => {
  const { isFullHeight, rounded, borderRadius = "xl", position } = props;
  return {
    ...isFullHeight && { height: "100vh" },
    ...rounded && {
      overflow: "hidden",
      ...position === "left" && {
        borderRightRadius: borderRadius
      },
      ...position === "right" && {
        borderLeftRadius: borderRadius
      },
      ...position === "top" && {
        borderBottomRadius: borderRadius
      },
      ...position === "bottom" && {
        borderTopRadius: borderRadius
      }
    },
    zIndex: "modal",
    bg: "base.primary",
    color: "inherit"
  };
};
var baseStyleHeader2 = {
  p: 3
};
var baseStyleCloseButton2 = {
  position: "absolute",
  top: 2,
  insetEnd: 3,
  marginLeft: "auto"
};
var baseStyleBody2 = {
  p: 3,
  flex: 1,
  overflow: "auto"
};
var baseStyleFooter2 = {
  p: 3
};
var baseStyle7 = (props) => ({
  overlay: baseStyleOverlay2,
  dialogContainer: baseStyleDialogContainer2,
  dialog: baseStyleDialog2(props),
  header: baseStyleHeader2,
  closeButton: baseStyleCloseButton2,
  body: baseStyleBody2,
  footer: baseStyleFooter2
});
var sizes5 = {
  xs: getSize2("25%"),
  sm: getSize2("35%"),
  md: getSize2("50%"),
  lg: getSize2("75%"),
  xl: getSize2("90%"),
  full: getSize2("full")
};
var variants4 = {
  mobileMd: {
    dialog: {
      height: "55%",
      borderTopRadius: "lg"
    }
  },
  mobileXl: {
    dialog: {
      height: "98%",
      borderTopRadius: "lg"
    }
  }
};
var defaultProps4 = {
  size: "md"
};
var Drawer2 = {
  parts: parts7.keys,
  baseStyle: baseStyle7,
  sizes: sizes5,
  variants: variants4,
  defaultProps: defaultProps4
};

// src/syt/components/Form.ts
import { formAnatomy as parts8 } from "@chakra-ui/anatomy";
var floatingLabelStyles2 = {
  initial: {
    top: ["18px", "18px", 3],
    left: 0,
    zIndex: 2,
    position: "absolute",
    backgroundColor: "transparent",
    pointerEvents: "none",
    color: "text.primary"
  },
  floating: {
    transform: "translateY(-100%)",
    color: "text.secondary",
    textStyle: "caption"
  },
  offsetStart: {
    left: 4.5
  }
};
var baseStyle8 = {
  container: {
    width: "100%",
    position: "relative"
  },
  helperText: {
    textStyle: "caption",
    color: "text.secondary",
    mt: 0.5
  }
};
var Form2 = {
  parts: parts8.keys,
  baseStyle: baseStyle8,
  variants: {
    floating: {
      container: {
        pt: [0.25, 0.25, 2],
        _focusWithin: {
          ".chakra-form__label": { ...floatingLabelStyles2.floating }
        },
        ".chakra-input__group": { position: "static" },
        "input:not(:placeholder-shown) + .chakra-form__label, .chakra-select__wrapper + .chakra-form__label, .chakra-react-select--has-value + .chakra-form__label": { ...floatingLabelStyles2.floating },
        ".chakra-form__label": { ...floatingLabelStyles2.initial },
        ".chakra-input__left-element ~ .chakra-form__label, .chakra-react-select--has-icon-left ~ .chakra-form__label": { ...floatingLabelStyles2.offsetStart }
      }
    }
  }
};

// src/syt/components/FormError.ts
import { formErrorAnatomy as parts9 } from "@chakra-ui/anatomy";
var baseStyleText2 = {
  color: "action.error",
  mt: 0.5,
  textStyle: "caption"
};
var baseStyleIcon2 = {
  marginEnd: 0.5,
  color: "action.error"
};
var baseStyle9 = {
  text: baseStyleText2,
  icon: baseStyleIcon2
};
var FormError2 = {
  parts: parts9.keys,
  baseStyle: baseStyle9
};

// src/syt/components/FormLabel.ts
var FormLabel2 = {
  baseStyle: {
    marginEnd: 3,
    mb: 2,
    transition: "color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    opacity: 1,
    _disabled: {
      opacity: 0.4
    },
    textStyle: "body",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
};

// src/syt/components/Heading.ts
var Heading2 = {
  baseStyle: {
    fontFamily: "heading"
  },
  sizes: null,
  variants: {},
  defaultProps: {
    size: null
  }
};

// src/syt/components/Icon.ts
var Icon2 = {
  baseStyle: {
    color: "text.base",
    display: "inline"
  },
  sizes: {
    sm: {
      w: 1,
      h: 1
    },
    md: {
      w: 2,
      h: 2
    },
    lg: {
      w: 3,
      h: 3
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/syt/components/Input.ts
import { inputAnatomy as parts10 } from "@chakra-ui/anatomy";
import {
  createMultiStyleConfigHelpers
} from "@chakra-ui/react";
var { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts10.keys);
var commonFieldStyle = {
  height: "auto",
  bgColor: ["base.white"],
  background: ["base.white"],
  borderBottomColor: ["line.secondary"],
  border: ["none"],
  fontFamily: "body"
};
var baseStyle10 = definePartsStyle({
  field: {
    ...commonFieldStyle,
    _focusVisible: {
      borderColor: "inherit",
      boxShadow: "none"
    },
    _placeholder: {
      fontFamily: "inherit"
    }
  },
  element: {
    ...commonFieldStyle
  },
  group: {
    ...commonFieldStyle
  },
  addon: {
    fontFamily: "inherit"
  }
});
var sizes6 = {
  md: {
    field: {},
    addon: {}
  }
};
var variants5 = {
  default: {
    ...baseStyle10
  }
};
var Input2 = defineMultiStyleConfig({
  baseStyle: baseStyle10,
  sizes: sizes6,
  variants: variants5,
  defaultProps: {
    size: "md",
    variant: "default"
  }
});

// src/syt/components/Link.ts
var Link2 = {
  baseStyle: {
    color: "text.primary",
    textDecoration: "none",
    _hover: {
      textDecoration: "none"
    },
    _focus: {
      textDecoration: "none"
    },
    _active: {
      textDecoration: "none"
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/syt/components/Menu.ts
import { theme as theme3 } from "@chakra-ui/react";
var Menu2 = theme3.components.Menu;

// src/syt/components/Modal.ts
import { modalAnatomy as parts11 } from "@chakra-ui/anatomy";

// ../../node_modules/@chakra-ui/styled-system/dist/esm/define-styles.mjs
function defineStyle(styles7) {
  return styles7;
}
function createMultiStyleConfigHelpers2(parts27) {
  return {
    definePartsStyle(config) {
      return config;
    },
    defineMultiStyleConfig(config) {
      return { parts: parts27, ...config };
    }
  };
}

// ../../node_modules/@chakra-ui/styled-system/dist/esm/get-css-var.mjs
function getCSSVar(theme7, scale, value) {
  return theme7.__cssMap?.[`${scale}.${value}`]?.varRef ?? value;
}

// ../../node_modules/@chakra-ui/styled-system/dist/esm/create-theme-vars/css-var.mjs
function replaceWhiteSpace(value, replaceValue = "-") {
  return value.replace(/\s+/g, replaceValue);
}
function escape(value) {
  const valueStr = replaceWhiteSpace(value.toString());
  return escapeSymbol(escapeDot(valueStr));
}
function escapeDot(value) {
  if (value.includes("\\."))
    return value;
  const isDecimal = !Number.isInteger(parseFloat(value.toString()));
  return isDecimal ? value.replace(".", `\\.`) : value;
}
function escapeSymbol(value) {
  return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function addPrefix(value, prefix = "") {
  return [prefix, value].filter(Boolean).join("-");
}
function toVarReference(name, fallback) {
  return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function toVarDefinition(value, prefix = "") {
  return escape(`--${addPrefix(value, prefix)}`);
}
function cssVar(name, fallback, cssVarPrefix) {
  const cssVariable = toVarDefinition(name, cssVarPrefix);
  return {
    variable: cssVariable,
    reference: toVarReference(cssVariable, fallback)
  };
}

// src/syt/components/Modal.ts
import { runIfFn } from "@chakra-ui/utils";
var { defineMultiStyleConfig: defineMultiStyleConfig2, definePartsStyle: definePartsStyle2 } = createMultiStyleConfigHelpers2(parts11.keys);
var $bg = cssVar("modal-bg");
var $shadow = cssVar("modal-shadow");
var baseStyleOverlay3 = defineStyle((props) => {
  return {
    bg: getCSSVar(props.theme, "colors.base", "halfBlack"),
    zIndex: "modal"
  };
});
var baseStyleDialogContainer3 = defineStyle((props) => {
  const { isCentered, scrollBehavior, size } = props;
  const isFull = size === "full";
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: isCentered ? "center" : "flex-start",
    p: isFull ? 0 : 2,
    overflow: scrollBehavior === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
});
var baseStyleDialog3 = defineStyle((props) => {
  const { isCentered, scrollBehavior } = props;
  return {
    borderRadius: "md",
    color: "inherit",
    my: isCentered ? "auto" : "16",
    mx: isCentered ? "auto" : void 0,
    zIndex: "modal",
    maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [$bg.variable]: "colors.white",
    [$shadow.variable]: "shadows.lg",
    _dark: {
      [$bg.variable]: "colors.gray.700",
      [$shadow.variable]: "shadows.dark-lg"
    },
    bg: $bg.reference,
    boxShadow: $shadow.reference
  };
});
var baseStyleHeader3 = defineStyle({
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
});
var baseStyleCloseButton3 = defineStyle({
  position: "absolute",
  top: "2",
  insetEnd: "3"
});
var baseStyleBody3 = defineStyle((props) => {
  const { scrollBehavior } = props;
  return {
    overflow: scrollBehavior === "inside" ? "auto" : void 0
  };
});
var baseStyleFooter3 = defineStyle({
  px: "6",
  py: "4"
});
var baseStyle11 = definePartsStyle2((props) => ({
  overlay: runIfFn(baseStyleOverlay3, props),
  dialogContainer: runIfFn(baseStyleDialogContainer3, props),
  dialog: runIfFn(baseStyleDialog3, props),
  header: baseStyleHeader3,
  closeButton: baseStyleCloseButton3,
  body: runIfFn(baseStyleBody3, props),
  footer: baseStyleFooter3
}));
function getSize3(value) {
  if (value === "full") {
    return definePartsStyle2({
      dialog: {
        maxW: "100vw",
        minH: "$100vh",
        my: "0",
        borderRadius: "0"
      }
    });
  }
  return definePartsStyle2({
    dialog: { maxW: value }
  });
}
var sizes7 = {
  xs: getSize3("xs"),
  sm: getSize3("sm"),
  md: getSize3("md"),
  lg: getSize3("lg"),
  xl: getSize3("xl"),
  "2xl": getSize3("2xl"),
  "3xl": getSize3("3xl"),
  "4xl": getSize3("4xl"),
  "5xl": getSize3("5xl"),
  "6xl": getSize3("6xl"),
  full: getSize3("full")
};
var Modal = defineMultiStyleConfig2({
  baseStyle: baseStyle11,
  sizes: sizes7,
  defaultProps: { size: "md" }
});

// src/syt/components/Radio.ts
var Radio2 = {
  baseStyle: {
    control: {
      w: 2,
      h: 2,
      bg: "base.white",
      borderRadius: "50%",
      transition: ".2s ease-out",
      _before: {
        content: '""',
        display: "block",
        width: "8px",
        height: "8px",
        bg: "base.grey",
        borderRadius: "50%"
      },
      _checked: {
        bg: "base.blue",
        _before: {
          bg: "base.white"
        }
      }
    },
    label: {
      textStyle: "body",
      _checked: {
        color: "base.blue"
      }
    }
  },
  defaultProps: {}
};

// src/syt/components/Skeleton.ts
import { keyframes as keyframes2 } from "@emotion/react";
var fade2 = () => keyframes2({
  from: { opacity: 1 },
  to: { opacity: 0.4 }
});
var Skeleton2 = {
  sizes: {
    sm: { w: [4.5, 8.5], h: [3, 3.5] },
    md: { w: [17.5, 32.5], h: [3, 3.5] },
    lg: { w: [26, 42], h: [4.5, 5.5] }
  },
  baseStyle: {
    borderRadius: "xs",
    borderColor: "base.secondary",
    background: "base.secondary",
    animation: `0.8s linear infinite alternate ${fade2()}`
  },
  defaultProps: {
    size: "md"
  }
};

// src/syt/components/Spinner.ts
var Spinner2 = {
  sizes: {
    md: { w: 2.5, h: 2.5 }
  },
  defaultProps: {
    size: "md"
  }
};

// src/syt/components/Switch.ts
import { switchAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers3, defineStyle as defineStyle2 } from "@chakra-ui/react";
var { definePartsStyle: definePartsStyle3, defineMultiStyleConfig: defineMultiStyleConfig3 } = createMultiStyleConfigHelpers3(switchAnatomy.keys);
var baseStyleContainer = defineStyle2({
  p: 0
  // ok
  // w: "56px",
  // h: "36px",
  // borderRadius: "36px",
});
var baseStyleTrack = defineStyle2({
  // px: "4px",
  // py: "5px",
  // w: "48px",
  // h: "26px",
  // borderRadius: "36px",
  transitionProperty: "all",
  transitionDuration: "150ms",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  _checked: {}
});
var baseStyleThumb = defineStyle2({
  bg: "white",
  transitionProperty: "all",
  transitionDuration: "150ms"
  // borderRadius: "26px",
  // width: "26px",
  // height: "26px",
  // _checked: {
  //     transform: "translateX(22px)",
  // },
});
var whiteAndBlue = definePartsStyle3({
  container: { ...baseStyleContainer },
  thumb: {
    ...baseStyleThumb,
    bg: "base.blue"
  },
  track: {
    ...baseStyleTrack,
    bg: "base.white"
  }
});
var black = definePartsStyle3({
  container: { ...baseStyleContainer },
  thumb: {
    ...baseStyleThumb,
    bg: "base.gunmetal"
  },
  track: {
    ...baseStyleTrack,
    bg: "base.white"
  }
});
var Switch = defineMultiStyleConfig3({
  variants: { whiteAndBlue, black },
  sizes: {
    sm: {
      container: { w: "32px", h: "20px" },
      thumb: {
        w: "14px",
        h: "14px",
        borderRadius: "14px",
        _checked: {
          transform: "translateX(14px)"
        }
      },
      track: {
        px: "2px",
        py: "3px",
        w: "28px",
        h: "14px",
        borderRadius: "20px"
      }
    },
    md: {
      container: { w: "56px", h: "36px" },
      thumb: {
        w: "26px",
        h: "26px",
        borderRadius: "26px",
        _checked: {
          transform: "translateX(22px)"
        }
      },
      track: {
        px: "4px",
        py: "5px",
        w: "48px",
        h: "26px",
        borderRadius: "36px"
      }
    }
  },
  defaultProps: {
    size: "md",
    colorScheme: "black"
  }
});

// src/syt/components/Table.ts
import { tableAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers4 } from "@chakra-ui/react";
var { defineMultiStyleConfig: defineMultiStyleConfig4 } = createMultiStyleConfigHelpers4(
  tableAnatomy.keys
);
var Table = defineMultiStyleConfig4({
  baseStyle: {
    tr: {
      "th:first-child": {}
    },
    th: {
      fontWeight: "bold",
      textAlign: "center",
      whiteSpace: "break-spaces",
      textTransform: "none"
    },
    td: {
      textAlign: "center",
      whiteSpace: "break-spaces"
    },
    tbody: {
      tr: {
        borderTop: "1px solid",
        borderColor: "base.grey"
      },
      "th:first-child": {
        textAlign: "left",
        verticalAlign: "middle"
      }
    },
    thead: {
      tr: {
        th: {
          verticalAlign: "bottom"
        }
      }
    }
  },
  sizes: {
    md: {
      table: {
        width: "100%",
        thead: {
          "tr:first-child": {
            td: {
              pt: 0
            },
            th: {
              pt: 0
            }
          }
        },
        tbody: {
          "tr:last-child": {
            td: {
              pb: 0
            },
            th: {
              pb: 0
            }
          }
        }
      },
      th: {
        py: [2],
        px: [0],
        lineHeight: "auto"
      },
      td: {
        py: [2],
        px: [0],
        lineHeight: "auto"
      }
    }
  },
  variants: {
    unstyled: {},
    highlightFirstColumn: {
      thead: {
        tr: {
          "th:nth-child(2)": {
            color: "base.blue"
          }
        }
      }
    }
  },
  defaultProps: { variant: "unstyled", size: "md" }
});

// src/syt/components/Tabs.ts
var Tabs2 = {
  baseStyle: {
    tab: {
      flexShrink: 0,
      h: ["36px", "36px", "42px"],
      bg: "base.grey",
      color: "text.base",
      px: [1, 1, 2],
      py: ["8px", "8px", "12px"],
      pt: 0,
      pb: 0,
      borderRadius: "50px",
      mr: 2,
      transition: ".3s ease-out",
      _selected: {
        bg: "base.gunmetal",
        color: "text.baseInverse"
      },
      _last: { mr: 0 },
      _focusVisible: {
        boxShadow: "none"
      }
    },
    tablist: {
      justifyContent: ["normal", "normal", "center"],
      minW: "100%",
      px: [2, 2, 0],
      mb: [3, 3, 4],
      overflowX: "scroll",
      "::-webkit-scrollbar": {
        display: "none"
      },
      borderBottom: "0px solid transparent"
    },
    tabpanel: {
      p: [0]
    }
  },
  sizes: {},
  variants: {
    dateSlider: {
      root: {
        maxW: "100%",
        bgColor: "base.grey",
        borderRadius: "8px"
      },
      tab: {
        flexDirection: "column",
        w: ["73px", "73px", "100px"],
        h: "auto",
        p: "8px",
        borderRadius: "8px",
        m: 0,
        _selected: {
          bg: "base.white",
          color: "text.base"
        }
      },
      tablist: {
        justifyContent: "initial",
        gap: "8px",
        p: 1,
        borderBottom: "none",
        mb: 0,
        _first: { pl: 1 },
        _last: { pr: 1 }
      }
    }
  },
  defaultProps: { variant: "unstyled" }
};

// src/syt/components/Tag.ts
var Tag2 = {
  parts: ["container"],
  baseStyle: {
    container: {
      px: 1,
      py: 0.5,
      textStyle: ["title3", "title3", "title1"],
      textTransform: "uppercase",
      borderRadius: "xs",
      minW: 0,
      minH: 0
    }
  },
  variants: {
    base: {
      container: {
        color: "text.primary",
        px: 0
      }
    },
    primary: {
      container: {
        backgroundColor: "base.primaryInverse",
        color: "text.primaryInverse"
      }
    },
    accent: {
      container: {
        backgroundColor: "base.accent",
        color: "text.primaryInverse"
      }
    }
  },
  defaultProps: {
    variant: "base"
  }
};

// src/syt/components/Text.ts
var Text2 = {
  baseStyle: {},
  variants: {
    base: {
      textStyle: "body",
      color: "text.base"
    },
    unstyled: {}
  },
  defaultProps: {
    variant: "base"
  }
};

// src/syt/index.ts
var SYTtheme = clearFromDefaultVars_default(
  extendTheme({
    config: {
      initialColorMode: "light",
      useSystemColorMode: false
    },
    direction: "ltr",
    borders: {},
    letterSpacings: null,
    lineHeights: null,
    styles: styles2,
    transition: { duration: {}, easing: {}, property: {} },
    components: components_exports2,
    ...foundations_exports2
  })
);

// src/sytDark/index.ts
import { extendTheme as extendTheme2 } from "@chakra-ui/react";

// src/sytDark/styles.ts
var styles3 = {
  global: {
    body: {
      fontFamily: "'Inter Display', sans-serif",
      bg: ["bg.base"],
      background: ["bg.base"],
      bgColor: ["bg.base"]
    },
    "html, body": {
      bg: ["bg.base"],
      background: ["bg.base"],
      bgColor: ["bg.base"]
    },
    a: {
      color: "base.blue"
    }
  }
};

// src/sytDark/foundations/index.ts
var foundations_exports3 = {};
__export(foundations_exports3, {
  colors: () => colors3
});

// src/sytDark/foundations/colors.ts
var colorGreyDark = "hsla(0, 0%, 27%, 1)";
var colorWhiteInverted = "hsla(15, 3%, 10%, 1)";
var colors3 = {
  base: {
    greyDark: colorGreyDark,
    success: colorSuccess
  },
  bg: {
    base: colorWhiteInverted,
    baseInverse: colorWhite,
    grey: colorGrey
  },
  secondary: {
    white: colorWhiteSecondary,
    bitterSweet: colorBitterSweetSecondary,
    blue: colorBlueSecondary,
    gunmetal: colorGunmetalSecondary,
    halfBlack: colorHalfBlackAlt,
    grey: colorGreyAlt
  },
  text: {
    base: colorWhite,
    baseInverse: colorGunmetal,
    primary: colorBitterSweet,
    accent: colorBlue
  }
};

// src/sytDark/components/index.ts
var components_exports3 = {};
__export(components_exports3, {
  Button: () => Button3
});

// src/sytDark/components/Button.ts
var getHoverAndFocusStyles3 = (styles7) => ({
  _hover: styles7,
  _focus: styles7
});
var Button3 = {
  baseStyle: {},
  variants: {
    red: {
      color: "text.base",
      bgColor: "base.bitterSweet",
      ...getHoverAndFocusStyles3({
        bgColor: "secondary.bitterSweet"
      }),
      _active: {
        bgColor: "base.bitterSweet",
        color: "secondary.white"
      },
      _disabled: {
        cursor: "default"
      },
      svg: {
        color: "text.base",
        fill: "text.base"
      }
    },
    white: {
      color: "text.baseInverse",
      border: "1px solid",
      borderColor: "base.white",
      bgColor: "base.white",
      ...getHoverAndFocusStyles3({
        bgColor: "secondary.white",
        borderColor: "secondary.white"
      }),
      _active: {
        color: "secondary.gunmetal"
      },
      _disabled: {
        cursor: "default"
      }
    },
    black: {
      color: "text.base",
      border: "1px solid",
      borderColor: "base.gunmetal",
      bgColor: "base.gunmetal",
      _disabled: {
        cursor: "default"
      }
    },
    success: {
      color: "text.base",
      bgColor: "base.success",
      ...getHoverAndFocusStyles3({
        bgColor: "base.success"
      }),
      _active: {
        bgColor: "base.success",
        color: "secondary.white"
      },
      _disabled: {
        cursor: "default"
      }
    }
  }
};

// src/sytDark/index.ts
var SYTthemeDark = clearFromDefaultVars_default(
  extendTheme2(SYTtheme, {
    config: {
      initialColorMode: "dark"
    },
    direction: "ltr",
    styles: styles3,
    components: components_exports3,
    ...foundations_exports3
  })
);

// src/sytLegacy/components/index.ts
var components_exports4 = {};
__export(components_exports4, {
  Alert: () => Alert3,
  Button: () => Button4,
  Checkbox: () => Checkbox3,
  Container: () => Container3,
  Divider: () => Divider3,
  Drawer: () => Drawer3,
  Form: () => Form3,
  FormError: () => FormError3,
  FormLabel: () => FormLabel3,
  Heading: () => Heading3,
  Icon: () => Icon3,
  Input: () => Input3,
  Link: () => Link3,
  Menu: () => Menu3,
  Radio: () => Radio3,
  Skeleton: () => Skeleton3,
  Spinner: () => Spinner3,
  Tabs: () => Tabs3,
  Tag: () => Tag3,
  Text: () => Text3
});

// src/sytLegacy/components/Button.ts
var getHoverAndFocusStyles4 = (styles7) => ({
  _hover: styles7,
  _focus: styles7
});
var Button4 = {
  baseStyle: {
    cursor: "pointer",
    textStyle: "action"
  },
  sizes: {
    sm: {
      h: [4, 4, 4.5],
      px: 1,
      borderRadius: "sm"
    },
    md: {
      py: ["8px", "8px", "12px"],
      px: ["14px", "14px", "20px"],
      borderRadius: "50px",
      fontSize: ["14px", "14px", "20px"],
      height: ["28px", "28px", "36px"]
    },
    lg: {
      py: 2,
      px: [3, 3, 5],
      borderRadius: "sm",
      minWidth: 18
    }
  },
  variants: {
    primary: {
      color: "text.primaryInverse",
      bg: "action.primary1",
      boxShadow: "mediumPrimary",
      ...getHoverAndFocusStyles4({
        bg: "action.primary1Press"
      }),
      _disabled: {
        cursor: "default"
      }
    },
    secondary: {
      color: "text.primary",
      bg: "action.tertiary",
      ...getHoverAndFocusStyles4({
        bg: "action.tertiaryPress"
      }),
      _disabled: {
        cursor: "default",
        bg: "action.tertiary"
      }
    },
    surface: {
      color: "text.primary",
      bg: "action.surface"
    },
    surfaceInverse: {
      color: "text.primaryInverse",
      bg: "action.surfaceInverse"
    },
    ghost: {
      color: "text.accent",
      ...getHoverAndFocusStyles4({
        color: "elevation.mediumPrimary"
      })
    },
    primaryInverse: {
      color: "text.primary",
      bg: "action.primary1Inverse",
      boxShadow: "mediumPrimaryInverse"
    },
    primary2: {
      color: "text.primaryInverse",
      bg: "action.primary2",
      ...getHoverAndFocusStyles4({
        bg: "action.primary2Inverse"
      })
    },
    attention: {
      color: "text.primaryInverse",
      bg: "action.attention",
      ...getHoverAndFocusStyles4({
        bg: "elevation.mediumAttention"
      })
    },
    disabled: {
      color: "text.primaryInverse",
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    success: {
      color: "text.baseInverse",
      bgColor: "base.success",
      ...getHoverAndFocusStyles4({
        bgColor: "base.success"
      }),
      _active: {
        bgColor: "base.success",
        color: "secondary.white"
      },
      _disabled: {
        cursor: "default"
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "primary"
  }
};

// src/sytLegacy/components/Container.ts
var spacingStyles2 = {
  xs: {
    mb: [3, 3, 5]
  },
  sm: {
    mb: [5, 5, 10]
  },
  md: {
    mb: [10, 10, 20]
  },
  none: {}
};
var Container3 = {
  baseStyle: ({ spacing }) => ({
    maxW: ["480px", "604px", "1208px"],
    w: "100%",
    mx: "auto",
    ...spacingStyles2[spacing === "default" ? "md" : spacing]
  }),
  variants: {
    base: {
      px: [3, 5, 0]
    }
  },
  defaultProps: {
    spacing: "none"
  }
};

// src/sytLegacy/components/Drawer.ts
import { drawerAnatomy as parts12 } from "@chakra-ui/anatomy";
function getSize4(value) {
  if (value === "full") {
    return {
      dialog: { maxW: "100vw", h: "100vh" }
    };
  }
  return {
    dialog: { maxW: value }
  };
}
var baseStyleOverlay4 = {
  bg: "base.overlay",
  zIndex: "overlay"
};
var baseStyleDialogContainer4 = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
};
var baseStyleDialog4 = (props) => {
  const { isFullHeight, rounded, borderRadius = "xl", position } = props;
  return {
    ...isFullHeight && { height: "100vh" },
    ...rounded && {
      overflow: "hidden",
      ...position === "left" && {
        borderRightRadius: borderRadius
      },
      ...position === "right" && {
        borderLeftRadius: borderRadius
      },
      ...position === "top" && {
        borderBottomRadius: borderRadius
      },
      ...position === "bottom" && {
        borderTopRadius: borderRadius
      }
    },
    zIndex: "modal",
    bg: "base.primary",
    color: "inherit"
  };
};
var baseStyleHeader4 = {
  p: 3
};
var baseStyleCloseButton4 = {
  position: "absolute",
  top: 2,
  insetEnd: 3,
  marginLeft: "auto"
};
var baseStyleBody4 = {
  p: 3,
  flex: 1,
  overflow: "auto"
};
var baseStyleFooter4 = {
  p: 3
};
var baseStyle12 = (props) => ({
  overlay: baseStyleOverlay4,
  dialogContainer: baseStyleDialogContainer4,
  dialog: baseStyleDialog4(props),
  header: baseStyleHeader4,
  closeButton: baseStyleCloseButton4,
  body: baseStyleBody4,
  footer: baseStyleFooter4
});
var sizes8 = {
  xs: getSize4("25%"),
  sm: getSize4("35%"),
  md: getSize4("50%"),
  lg: getSize4("75%"),
  xl: getSize4("90%"),
  full: getSize4("full")
};
var variants6 = {
  mobileMd: {
    dialog: {
      height: "55%",
      borderTopRadius: "lg"
    }
  },
  mobileXl: {
    dialog: {
      height: "98%",
      borderTopRadius: "lg"
    }
  }
};
var defaultProps5 = {
  size: "md"
};
var Drawer3 = {
  parts: parts12.keys,
  baseStyle: baseStyle12,
  sizes: sizes8,
  variants: variants6,
  defaultProps: defaultProps5
};

// src/sytLegacy/components/Form.ts
import { formAnatomy as parts13 } from "@chakra-ui/anatomy";
var floatingLabelStyles3 = {
  initial: {
    top: ["18px", "18px", 3],
    left: 0,
    zIndex: 2,
    position: "absolute",
    backgroundColor: "transparent",
    pointerEvents: "none",
    color: "text.primary"
  },
  floating: {
    transform: "translateY(-100%)",
    color: "text.secondary",
    textStyle: "caption"
  },
  offsetStart: {
    left: 4.5
  }
};
var baseStyle13 = {
  container: {
    width: "100%",
    position: "relative"
  },
  helperText: {
    textStyle: "caption",
    color: "text.secondary",
    mt: 0.5
  }
};
var Form3 = {
  parts: parts13.keys,
  baseStyle: baseStyle13,
  variants: {
    floating: {
      container: {
        pt: [0.25, 0.25, 2],
        _focusWithin: {
          ".chakra-form__label": { ...floatingLabelStyles3.floating }
        },
        ".chakra-input__group": { position: "static" },
        "input:not(:placeholder-shown) + .chakra-form__label, .chakra-select__wrapper + .chakra-form__label, .chakra-react-select--has-value + .chakra-form__label": { ...floatingLabelStyles3.floating },
        ".chakra-form__label": { ...floatingLabelStyles3.initial },
        ".chakra-input__left-element ~ .chakra-form__label, .chakra-react-select--has-icon-left ~ .chakra-form__label": { ...floatingLabelStyles3.offsetStart }
      }
    }
  }
};

// src/sytLegacy/components/FormLabel.ts
var FormLabel3 = {
  baseStyle: {
    marginEnd: 3,
    mb: 2,
    transition: "color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    opacity: 1,
    _disabled: {
      opacity: 0.4
    },
    textStyle: "body",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
};

// src/sytLegacy/components/FormError.ts
import { formErrorAnatomy as parts14 } from "@chakra-ui/anatomy";
var baseStyleText3 = {
  color: "action.error",
  mt: 0.5,
  textStyle: "caption"
};
var baseStyleIcon3 = {
  marginEnd: 0.5,
  color: "action.error"
};
var baseStyle14 = {
  text: baseStyleText3,
  icon: baseStyleIcon3
};
var FormError3 = {
  parts: parts14.keys,
  baseStyle: baseStyle14
};

// src/sytLegacy/components/Icon.ts
var Icon3 = {
  baseStyle: {
    color: "text.primary",
    display: "inline"
  },
  sizes: {
    sm: {
      w: 2,
      h: 2
    },
    md: {
      w: 3,
      h: 3
    },
    lg: {
      w: 6,
      h: 6
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/sytLegacy/components/Input.ts
import { inputAnatomy as parts15 } from "@chakra-ui/anatomy";

// src/sytLegacy/foundations/index.ts
var foundations_exports4 = {};
__export(foundations_exports4, {
  breakpoints: () => breakpoints3,
  colors: () => colors4,
  fontSizes: () => fontSizes3,
  fontWeights: () => fontWeights3,
  fonts: () => fonts3,
  lineHeights: () => lineHeights2,
  radii: () => radii3,
  shadows: () => shadows3,
  sizes: () => sizes9,
  space: () => space2,
  textStyles: () => textStyles3,
  zIndices: () => zIndices3
});

// src/sytLegacy/foundations/breakpoints.ts
var breakpoints3 = {
  base: "0em",
  tablet: "1024px",
  desktop: "1280px",
  desktopXL: "1600px"
};

// src/sytLegacy/foundations/space.ts
var space2 = {
  0: "0px",
  0.25: "2px",
  0.5: "4px",
  0.75: "6px",
  1: "8px",
  1.25: "10px",
  1.5: "12px",
  1.75: "14px",
  2: "16px",
  2.5: "20px",
  3: "24px",
  3.5: "28px",
  4: "32px",
  4.5: "36px",
  5: "40px",
  5.5: "44px",
  6: "48px",
  6.5: "52px",
  7: "56px",
  8: "64px",
  10: "80px",
  12: "96px",
  20: "160px"
};

// src/sytLegacy/foundations/colors.ts
var colors4 = {
  base: {
    primary: "hsla(0, 0%, 100%, 1)",
    secondary: "hsla(0, 0%, 96%, 1)",
    overlay: "hsla(0, 0%, 0%, 0.35)",
    overlayInverse: "hsla(0, 0%, 0%, 0.9)",
    accent: colorBitterSweet,
    primaryInverse: "hsla(0, 0%, 3%, 1)",
    secondaryInverse: "hsla(0, 0%, 16%, 1)",
    surface: "hsla(0, 0%, 100%, 0.7)",
    surfaceInverse: "hsla(0, 0%, 12%, 0.7)",
    surfacePrimary: "rgba(255, 255, 255, 0.7)",
    surfaceSecondary: "rgba(242, 242, 242, 0.5)",
    accentGradient: "linear-gradient(90deg, hsla(1, 100%, 75%, 1), hsla(1, 80%, 59%, 1))",
    transparent: "hsla(0, 0%, 0%, 0)",
    dashboard: "hsla(44, 50%, 94%, 1)",
    gradient: "linear-gradient(91.25deg, #FFFBEF 9.36%, #FDEFEF 68.08%)",
    gradient2: "linear-gradient(91.25deg, hsla(44, 100%, 97%, 1), hsla(0, 78%, 96%, 1))",
    logo: "hsla(230, 80%, 52%, 1)",
    autofill: "transparent"
  },
  action: {
    primary1: colorBitterSweet,
    primary1Inverse: colorBitterSweet,
    primary2: "hsla(220, 96%, 45%, 1)",
    primary2Inverse: "hsla(220, 96%, 60%, 1)",
    primary1Press: colorBitterSweetSecondary,
    primaryBitterSweet: colorBitterSweet,
    secondary: colorBitterSweet,
    tertiary: "hsla(0, 0%, 0%, 0.04)",
    tertiaryInverse: "hsla(0, 0%, 94%, 0.6)",
    tertiaryPress: "hsla(0, 0%, 0%, 0.08)",
    surface: "hsla(0, 0%, 100%, 0.6)",
    surfaceInverse: "hsla(0, 0%, 100%, 0.3)",
    attention: "hsla(31, 95%, 56%, 1)",
    success: "hsla(130, 53%, 58%, 1)",
    disabled: "hsla(0, 0%, 0%, 0.03)",
    input: "hsla(216, 14%, 93%, 1)",
    error: "hsla(349, 92%, 48%, 1)",
    hover: "hsla(1, 78%, 54%, 1)",
    tinted: colorBitterSweet
  },
  elevation: {
    low: "hsla(0, 0%, 0%, 0.09)",
    medium: "hsla(0, 0%, 0%, 0.12)",
    high: "hsla(0, 0%, 0%, 0.2)",
    mediumPrimary: "hsla(1, 78%, 64%, 0.3)",
    mediumPrimary2: "hsla(234, 78%, 64%, 0.3)",
    mediumAttention: "hsla(31, 78%, 64%, 0.3)",
    mediumSuccess: "hsla(130, 78%, 64%, 0.3)"
  },
  text: {
    primary: colorGunmetal,
    primaryInverse: colorWhite,
    primaryContrast: colorGunmetal,
    primaryContrastInverse: colorBitterSweet,
    secondary: "hsla(190, 3%, 34%, 0.6)",
    secondaryInverse: "hsla(207, 100%, 100%, 0.7)",
    secondaryContrast: "hsla(190, 3%, 34%, 0.6)",
    secondaryContrastInverse: "hsla(207, 100%, 100%, 0.7)",
    tertiary: "hsla(207, 14%, 9%, 0.22)",
    tertiaryInverse: "hsla(0, 0%, 100%, 0.4)",
    tertiaryContrast: "hsla(207, 14%, 9%, 0.22)",
    tertiaryContrastInverse: "hsla(0, 0%, 100%, 0.4)",
    placeholder: "hsla(190, 3%, 75%, 0.6)",
    accent: colorBitterSweet,
    accentInverse: colorBitterSweet,
    link: "hsla(234, 100%, 50%, 1)",
    linkInverse: "hsla(234, 100%, 50%, 1)",
    disabled: "hsla(190, 5%, 74%, 0.4)",
    disabledInverse: "hsla(190, 5%, 74%, 0.4)",
    disabledContrast: "hsla(190, 5%, 74%, 0.4)",
    disabledContrastInverse: "hsla(190, 5%, 74%, 0.4)"
  },
  line: {
    primary: colorBitterSweet,
    secondary: "hsla(207, 14%, 30%, 0.1)",
    primaryInverse: colorBitterSweet,
    secondaryInverse: "hsla(0, 0%, 100%, 0.3)"
  },
  brand: {
    cultured: "hsla(190, 21%, 95%, 1)",
    lavendar: "hsla(0, 78%, 96%, 1)",
    charcoal: "hsla(207, 14%, 30%, 1)",
    honey: "hsla(42, 100%, 50%, 1)"
  },
  tint: {
    success: "hsla(130, 53%, 58%, 1)",
    attention: "hsla(31, 95%, 56%, 1)"
  }
};

// src/sytLegacy/foundations/fonts.ts
var fonts3 = {
  body: `'Inter', sans-serif`,
  heading: `'Inter Display', sans-serif`
};

// src/sytLegacy/foundations/sizes.ts
var sizes9 = {
  0.5: "4px",
  1: "8px",
  1.5: "12px",
  2: "16px",
  2.5: "20px",
  3: "24px",
  3.5: "28px",
  4: "32px",
  4.5: "36px",
  5: "40px",
  5.5: "44px",
  6: "48px",
  6.5: "52px",
  7: "56px",
  8: "64px",
  8.5: "68px",
  10: "80px",
  12: "96px",
  17.5: "140px",
  18: "144px",
  25: "200px",
  26: "208px",
  32.5: "260px",
  42: "336px"
};

// src/sytLegacy/foundations/fontSizes.ts
var fontSizes3 = {
  11: "11px",
  13: "13px",
  15: "15px",
  17: "17px",
  20: "20px",
  22: "22px",
  28: "28px",
  35: "35px",
  40: "40px",
  45: "45px",
  50: "50px",
  64: "64px",
  96: "96px",
  144: "142px",
  240: "240px"
};

// src/sytLegacy/foundations/fontWeights.ts
var fontWeights3 = {
  body: 400,
  heading: 600,
  bold: 600
};

// src/sytLegacy/foundations/lineHeights.ts
var lineHeights2 = {
  normal: "normal",
  inherit: "inherit",
  base: "140%",
  heading: "120%",
  2: "16px",
  3: "24px",
  5: "40px"
};

// src/sytLegacy/foundations/textStyles.ts
var textStyles3 = {
  display1: {
    fontSize: [45, 45, 64],
    lineHeight: "100%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  display2: {
    fontSize: [40, 40, 50],
    lineHeight: "100%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  title1: {
    fontSize: [28, 28, 35],
    lineHeight: "120%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  title2: {
    fontSize: [22, 22, 28],
    fontWeight: "heading",
    lineHeight: "120%",
    letterSpacing: "-0.02em"
  },
  title3: {
    fontSize: [17, 17, 20],
    fontWeight: "heading",
    lineHeight: "120%",
    letterSpacing: "0em"
  },
  title4: {
    fontSize: [13, 13, 17],
    lineHeight: "120%",
    fontWeight: "heading",
    letterSpacing: "0.04em",
    textTransform: "uppercase"
  },
  body: {
    fontSize: [17, 17, 20],
    lineHeight: "140%"
  },
  caption: {
    fontSize: [13, 13, 17],
    lineHeight: "140%"
  },
  captionSmall: {
    fontSize: [11, 11, 15],
    lineHeight: "140%"
  },
  action: {
    fontSize: [17, 17, 20],
    lineHeight: "120%",
    fontWeight: "bold"
  }
};

// src/sytLegacy/foundations/radii.ts
var radii3 = {
  none: "0",
  base: "10px",
  xs: "4px",
  sm: "10px",
  md: "16px",
  lg: "22px",
  xl: "28px"
};

// src/sytLegacy/foundations/zIndices.ts
var zIndices3 = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 20,
  sticky: 30,
  banner: 40,
  overlay: 50,
  modal: 60,
  popover: 70,
  skipLink: 80,
  toast: 90,
  tooltip: 100
};

// src/sytLegacy/foundations/shadows.ts
var shadows3 = {
  low: "0px 1px 10px 0px rgba(0, 0, 0, 0.09)",
  medium: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
  mediumPrimary: "0px 4px 12px 0px rgba(235, 94, 91, 0.3)",
  mediumPrimaryInverse: "0px 4px 12px rgba(0, 0, 0, 0.12)",
  mediumPrimary2: "0px 4px 12px 0px rgba(91, 105, 235, 0.3)",
  mediumSuccess: "0px 4px 12px 0px rgba(91, 235, 115, 0.3)",
  mediumAttention: "0px 4px 12px 0px rgba(235, 165, 91, 0.3)",
  high: "0px 10px 40px rgba(0, 0, 0, 0.2)",
  box: {
    base: "0px 0px 0px 1px hsla(207, 14%, 30%, 0.1)",
    selected: "0px 0px 0px 2px hsla(1, 78%, 64%, 1)"
  }
};

// src/sytLegacy/components/Input.ts
var baseStyle15 = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    color: "text.primary",
    ".chakra-input__left-element ~ &": {
      pl: 4.5
    },
    ".chakra-input__right-element ~ &": {
      pr: 4.5
    },
    fontFamily: "'Inter Display', sans-serif",
    borderBottomColor: ["line.secondary"]
  },
  group: {
    height: "auto",
    borderBottomColor: ["line.secondary"],
    fontFamily: "'Inter Display', sans-serif"
  },
  element: {
    boxSizing: "content-box",
    width: 3,
    fontFamily: "'Inter Display', sans-serif",
    borderBottomColor: ["line.secondary"]
  },
  addon: {
    fontFamily: "'Inter Display', sans-serif"
  }
};
var variantFlushed2 = {
  field: {
    width: "100%",
    borderBottom: "1px solid",
    borderColor: "line.secondary",
    borderBottomColor: ["line.secondary"],
    borderRadius: 0,
    px: 0,
    bg: "transparent",
    fontFamily: "body",
    _readOnly: {
      boxShadow: "none !important",
      userSelect: "all"
    },
    _focus: {
      borderColor: "text.link"
    },
    _invalid: {
      borderColor: "action.error"
    },
    _placeholder: {
      transition: "all 0.3s"
    },
    _focusVisible: {
      borderColor: "inherit",
      boxShadow: "none"
    }
  },
  group: {
    borderBottomColor: ["line.secondary"]
  },
  addon: {
    borderBottom: "1px solid",
    borderBottomColor: ["line.secondary"],
    borderRadius: 0,
    px: 0,
    bg: "transparent"
  }
};
var sizes10 = {
  md: {
    field: {
      h: [7, 7, 5.5],
      ...textStyles3.body
    },
    addon: {
      h: [7, 7, 5.5],
      ...textStyles3.body
    }
  }
};
var Input3 = {
  parts: parts15.keys,
  baseStyle: baseStyle15,
  sizes: sizes10,
  variants: {
    flushed: variantFlushed2
  },
  defaultProps: {
    size: "md",
    variant: "flushed"
  }
};

// src/sytLegacy/components/Radio.ts
var Radio3 = {
  baseStyle: {
    label: {
      userSelect: "none",
      _disabled: { opacity: 0.4 }
    },
    control: {
      w: "100%",
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      color: "base.secondary",
      bg: "text.placeholder",
      borderRadius: "50%",
      _checked: {
        bg: "base.accent",
        _before: {
          content: '""',
          display: "inline-block",
          pos: "relative",
          w: 1,
          h: 1,
          borderRadius: "50%",
          bg: "text.primaryInverse"
        }
      },
      _disabled: {
        _hover: {
          cursor: "not-allowed",
          borderColor: "base.secondary"
        }
      }
    }
  },
  sizes: {
    md: {
      control: { w: 3, h: 3 }
    }
  },
  defaultProps: {
    size: "md",
    colorScheme: "base.checkbox"
  }
};

// src/sytLegacy/components/Skeleton.ts
import { keyframes as keyframes3 } from "@emotion/react";
var fade3 = () => keyframes3({
  from: { opacity: 1 },
  to: { opacity: 0.4 }
});
var Skeleton3 = {
  sizes: {
    sm: { w: [4.5, 8.5], h: [3, 3.5] },
    md: { w: [17.5, 32.5], h: [3, 3.5] },
    lg: { w: [26, 42], h: [4.5, 5.5] }
  },
  baseStyle: {
    borderRadius: "xs",
    borderColor: "base.secondary",
    background: "base.secondary",
    animation: `0.8s linear infinite alternate ${fade3()}`
  },
  defaultProps: {
    size: "md"
  }
};

// src/sytLegacy/components/Spinner.ts
var Spinner3 = {
  sizes: {
    md: { w: 2.5, h: 2.5 }
  },
  defaultProps: {
    size: "md"
  }
};

// src/sytLegacy/components/Heading.ts
var Heading3 = {
  baseStyle: {
    textStyle: "display1",
    color: "text.primary"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/sytLegacy/components/Text.ts
var Text3 = {
  variants: {
    base: {
      textStyle: "body",
      color: "text.primary"
    },
    unstyled: {}
  },
  defaultProps: {
    variant: "base"
  }
};

// src/sytLegacy/components/Checkbox.ts
var Checkbox3 = {
  baseStyle: {
    control: {
      outline: "none"
    },
    label: {
      userSelect: "none"
    }
  },
  sizes: {
    sm: {
      icon: { h: "10px" },
      control: { w: 2.5, h: 2.5 }
    },
    md: {
      icon: { h: "10px" },
      control: { w: 3, h: 3 }
    }
  },
  variants: {
    primary: {
      icon: {
        color: "text.primaryInverse"
      },
      container: {
        w: "100%",
        flexDirection: "row-reverse",
        justifyContent: "space-between"
      },
      control: {
        border: "1px solid",
        borderColor: "text.primary",
        borderRadius: "2px",
        bg: "text.primaryInverse",
        "& > svg": {
          display: "none",
          color: "text.primaryInverse"
        },
        _checked: {
          bg: "action.primary1",
          borderColor: "action.primary1",
          _hover: {
            bg: "action.primary1",
            borderColor: "action.primary1"
          },
          "& > svg": {
            display: "block"
          }
        },
        _focus: {
          boxShadow: "none"
        },
        _hover: {
          borderColor: "action.primary1"
        }
      },
      label: {
        ...textStyles3.body,
        ml: 0,
        mr: 2
      }
    },
    secondary: {
      icon: {
        color: "text.primaryInverse"
      },
      container: {
        w: "100%",
        flexDirection: "row-reverse",
        justifyContent: "space-between"
      },
      control: {
        border: "none",
        borderRadius: "sm",
        bg: "text.placeholder",
        _checked: {
          bg: "action.primary1",
          _hover: {
            bg: "action.primary1"
          }
        },
        _focus: {
          boxShadow: "none"
        }
      },
      label: {
        ...textStyles3.caption,
        ml: 0,
        mr: 2
      }
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/sytLegacy/components/Tabs.ts
var Tabs3 = {
  parts: ["root", "tab", "tablist"],
  baseStyle: {
    tab: {
      h: ["36px", 7],
      color: "text.primary",
      border: "1px solid",
      borderColor: "line.secondary",
      borderRadius: "xl",
      px: 2,
      py: [1, 2],
      textStyle: "action",
      _hover: {
        bg: "base.surfaceSecondary",
        color: "text.primary",
        cursor: "pointer",
        borderColor: "line.secondary"
      },
      _selected: {
        color: "text.primaryInverse",
        bg: "base.primaryInverse",
        borderColor: "base.primaryInverse"
      }
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/sytLegacy/components/Alert.ts
var parts16 = ["container", "icon", "title", "description", "spinner"];
var baseStyle16 = {
  container: {
    p: 3,
    display: "flex"
  },
  title: {
    fontWeight: "bold",
    textStyle: "title2",
    mb: 1
  },
  description: {
    textStyle: "body"
  },
  icon: {
    flexShrink: 0,
    marginEnd: 1,
    w: "20px",
    h: "20px"
  }
};
var variantLeftAccent3 = () => {
  return {
    container: {
      borderColor: "base.overlay",
      borderWidth: "1px",
      borderRadius: "md",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    title: {
      color: "text.secondary"
    },
    icon: {},
    description: {
      color: "text.secondary"
    }
  };
};
var variantTopAccent3 = () => {
  return {
    container: {
      flexDirection: "column"
    },
    icon: {},
    description: {}
  };
};
var variants7 = {
  "left-accent": variantLeftAccent3,
  "top-accent": variantTopAccent3
};
var defaultProps6 = {
  variant: "left-accent"
};
var Alert3 = {
  parts: parts16,
  baseStyle: baseStyle16,
  variants: variants7,
  defaultProps: defaultProps6
};

// src/sytLegacy/components/Link.ts
var Link3 = {
  baseStyle: {
    color: "text.primary"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/sytLegacy/components/Tag.ts
var Tag3 = {
  parts: ["container"],
  baseStyle: {
    container: {
      px: 1,
      py: 0.5,
      textStyle: ["title3", "title3", "title1"],
      textTransform: "uppercase",
      borderRadius: "xs"
    }
  },
  variants: {
    base: {
      container: {
        color: "text.primary",
        px: 0
      }
    },
    primary: {
      container: {
        backgroundColor: "base.primaryInverse",
        color: "text.primaryInverse"
      }
    },
    accent: {
      container: {
        backgroundColor: "base.accent",
        color: "text.primaryInverse"
      }
    }
  },
  defaultProps: {
    variant: "base"
  }
};

// src/sytLegacy/components/Divider.ts
var Divider3 = {
  baseStyle: {
    borderWidth: ["1px", "1px", "2px"],
    borderColor: "line.secondary",
    borderStyle: "solid"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/sytLegacy/components/Menu.ts
import { theme as theme4 } from "@chakra-ui/react";
var Menu3 = theme4.components.Menu;

// src/sytLegacy/styles.ts
var styles_exports2 = {};
__export(styles_exports2, {
  styles: () => styles4
});
var styles4 = {
  global: {
    body: {
      fontFamily: "body"
    },
    "html, body": {
      background: "base.primary"
    },
    em: {
      fontStyle: "italic"
    },
    mark: {
      color: "text.link",
      fontStyle: "normal",
      backgroundColor: "unset"
    },
    a: {
      color: "text.link"
    }
  }
};

// src/sytLegacy/index.ts
var SYTLegacyTheme = {
  config: {
    initialColorMode: "light"
  },
  direction: "ltr",
  borders: {},
  letterSpacings: {},
  transition: {
    property: {},
    easing: {},
    duration: {}
  },
  components: components_exports4,
  ...styles_exports2,
  ...foundations_exports4
};

// src/dr-smile/components/index.ts
var components_exports5 = {};
__export(components_exports5, {
  Alert: () => Alert4,
  Button: () => Button5,
  Checkbox: () => Checkbox4,
  Container: () => Container4,
  Divider: () => Divider4,
  Drawer: () => Drawer4,
  Form: () => Form4,
  FormError: () => FormError4,
  FormLabel: () => FormLabel4,
  Heading: () => Heading4,
  Icon: () => Icon4,
  Input: () => Input4,
  Link: () => Link4,
  Menu: () => Menu4,
  Radio: () => Radio4,
  Skeleton: () => Skeleton4,
  Spinner: () => Spinner4,
  Tabs: () => Tabs4,
  Tag: () => Tag4,
  Text: () => Text4
});

// src/dr-smile/components/Button.ts
var getHoverAndFocusStyles5 = (styles7) => ({
  _hover: styles7,
  _focus: styles7
});
var Button5 = {
  baseStyle: {
    cursor: "pointer",
    textStyle: "action"
  },
  sizes: {
    sm: {
      h: [4, 4, 4.5],
      px: 1,
      borderRadius: "sm"
    },
    md: {
      py: 2,
      px: [3, 3, 5],
      borderRadius: "md",
      minWidth: 18
    },
    lg: {
      py: 2,
      px: [3, 3, 5],
      borderRadius: "md",
      minWidth: 18
    }
  },
  variants: {
    primary: {
      color: "text.primaryInverse",
      bg: "action.primary1",
      boxShadow: "mediumPrimary",
      ...getHoverAndFocusStyles5({
        bg: "action.primary1Press"
      }),
      _disabled: {
        cursor: "default"
      }
    },
    secondary: {
      color: "text.primary",
      bg: "action.tertiary",
      ...getHoverAndFocusStyles5({
        bg: "action.tertiaryPress"
      }),
      _disabled: {
        cursor: "default",
        bg: "action.tertiary"
      }
    },
    surface: {
      color: "text.primary",
      bg: "action.surface"
    },
    surfaceInverse: {
      color: "text.primaryInverse",
      bg: "action.surfaceInverse"
    },
    ghost: {
      color: "text.accent",
      ...getHoverAndFocusStyles5({
        color: "elevation.mediumPrimary"
      })
    },
    primaryInverse: {
      color: "text.primary",
      bg: "action.primary1Inverse",
      boxShadow: "mediumPrimaryInverse"
    },
    primary2: {
      color: "text.primaryInverse",
      bg: "action.primary2",
      ...getHoverAndFocusStyles5({
        bg: "action.primary2Inverse"
      })
    },
    attention: {
      color: "text.primaryInverse",
      bg: "action.attention",
      ...getHoverAndFocusStyles5({
        bg: "elevation.mediumAttention"
      })
    },
    success: {
      color: "text.primaryInverse",
      bgColor: "action.success",
      ...getHoverAndFocusStyles5({
        bg: "elevation.mediumSuccess"
      })
    },
    disabled: {
      color: "text.primaryInverse",
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    }
  },
  defaultProps: {
    size: "md",
    variant: "primary"
  }
};

// src/dr-smile/components/Container.ts
var spacingStyles3 = {
  xs: {
    mb: [3, 3, 5]
  },
  sm: {
    mb: [5, 5, 10]
  },
  md: {
    mb: [10, 10, 20]
  },
  none: {}
};
var Container4 = {
  baseStyle: ({ spacing }) => ({
    maxW: ["480px", "604px", "1208px"],
    w: "100%",
    mx: "auto",
    ...spacingStyles3[spacing === "default" ? "md" : spacing]
  }),
  variants: {
    base: {
      px: [3, 5, 0]
    }
  },
  defaultProps: {
    spacing: "none"
  }
};

// src/dr-smile/components/Drawer.ts
import { drawerAnatomy as parts17 } from "@chakra-ui/anatomy";
function getSize5(value) {
  if (value === "full") {
    return {
      dialog: { maxW: "100vw", h: "100vh" }
    };
  }
  return {
    dialog: { maxW: value }
  };
}
var baseStyleOverlay5 = {
  bg: "base.overlay",
  zIndex: "overlay"
};
var baseStyleDialogContainer5 = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
};
var baseStyleDialog5 = (props) => {
  const { isFullHeight, rounded, borderRadius = "xl", position } = props;
  return {
    ...isFullHeight && { height: "100vh" },
    ...rounded && {
      overflow: "hidden",
      ...position === "left" && {
        borderRightRadius: borderRadius
      },
      ...position === "right" && {
        borderLeftRadius: borderRadius
      },
      ...position === "top" && {
        borderBottomRadius: borderRadius
      },
      ...position === "bottom" && {
        borderTopRadius: borderRadius
      }
    },
    zIndex: "modal",
    bg: "base.primary",
    color: "inherit"
  };
};
var baseStyleHeader5 = {
  p: 3
};
var baseStyleCloseButton5 = {
  position: "absolute",
  top: 2,
  insetEnd: 3,
  marginLeft: "auto"
};
var baseStyleBody5 = {
  p: 3,
  flex: 1,
  overflow: "auto"
};
var baseStyleFooter5 = {
  p: 3
};
var baseStyle17 = (props) => ({
  overlay: baseStyleOverlay5,
  dialogContainer: baseStyleDialogContainer5,
  dialog: baseStyleDialog5(props),
  header: baseStyleHeader5,
  closeButton: baseStyleCloseButton5,
  body: baseStyleBody5,
  footer: baseStyleFooter5
});
var sizes11 = {
  xs: getSize5("25%"),
  sm: getSize5("35%"),
  md: getSize5("50%"),
  lg: getSize5("75%"),
  xl: getSize5("90%"),
  full: getSize5("full")
};
var variants8 = {
  mobileMd: {
    dialog: {
      height: "55%",
      borderTopRadius: "lg"
    }
  },
  mobileXl: {
    dialog: {
      height: "98%",
      borderTopRadius: "lg"
    }
  }
};
var defaultProps7 = {
  size: "md"
};
var Drawer4 = {
  parts: parts17.keys,
  baseStyle: baseStyle17,
  sizes: sizes11,
  variants: variants8,
  defaultProps: defaultProps7
};

// src/dr-smile/components/Form.ts
import { formAnatomy as parts18 } from "@chakra-ui/anatomy";
var floatingLabelStyles4 = {
  initial: {
    top: ["18px", "18px", 3],
    left: 0,
    zIndex: 2,
    position: "absolute",
    backgroundColor: "transparent",
    pointerEvents: "none",
    color: "text.primary"
  },
  floating: {
    transform: "translateY(-100%)",
    color: "text.secondary",
    textStyle: "caption"
  },
  offsetStart: {
    left: 4.5
  }
};
var baseStyle18 = {
  container: {
    width: "100%",
    position: "relative"
  },
  helperText: {
    textStyle: "caption",
    color: "text.secondary",
    mt: 0.5
  }
};
var Form4 = {
  parts: parts18.keys,
  baseStyle: baseStyle18,
  variants: {
    floating: {
      container: {
        pt: [0.25, 0.25, 2],
        _focusWithin: {
          ".chakra-form__label": { ...floatingLabelStyles4.floating }
        },
        ".chakra-input__group": { position: "static" },
        "input:not(:placeholder-shown) + .chakra-form__label, .chakra-select__wrapper + .chakra-form__label, .chakra-react-select--has-value + .chakra-form__label": { ...floatingLabelStyles4.floating },
        ".chakra-form__label": { ...floatingLabelStyles4.initial },
        ".chakra-input__left-element ~ .chakra-form__label, .chakra-react-select--has-icon-left ~ .chakra-form__label": { ...floatingLabelStyles4.offsetStart }
      }
    }
  }
};

// src/dr-smile/components/FormLabel.ts
var FormLabel4 = {
  baseStyle: {
    marginEnd: 3,
    mb: 2,
    transition: "color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    opacity: 1,
    _disabled: {
      opacity: 0.4
    },
    textStyle: "body",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
};

// src/dr-smile/components/FormError.ts
import { formErrorAnatomy as parts19 } from "@chakra-ui/anatomy";
var baseStyleText4 = {
  color: "action.error",
  mt: 0.5,
  textStyle: "caption"
};
var baseStyleIcon4 = {
  marginEnd: 0.5,
  color: "action.error"
};
var baseStyle19 = {
  text: baseStyleText4,
  icon: baseStyleIcon4
};
var FormError4 = {
  parts: parts19.keys,
  baseStyle: baseStyle19
};

// src/dr-smile/components/Icon.ts
var Icon4 = {
  baseStyle: {
    color: "text.primary",
    display: "inline"
  },
  sizes: {
    sm: {
      w: 2,
      h: 2
    },
    md: {
      w: 3,
      h: 3
    },
    lg: {
      w: 6,
      h: 6
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/dr-smile/components/Input.ts
import { inputAnatomy as parts20 } from "@chakra-ui/anatomy";

// src/dr-smile/foundations/index.ts
var foundations_exports5 = {};
__export(foundations_exports5, {
  breakpoints: () => breakpoints4,
  colors: () => colors5,
  fontSizes: () => fontSizes4,
  fontWeights: () => fontWeights4,
  fonts: () => fonts4,
  lineHeights: () => lineHeights3,
  radii: () => radii4,
  shadows: () => shadows4,
  sizes: () => sizes12,
  space: () => space3,
  textStyles: () => textStyles4,
  zIndices: () => zIndices4
});

// src/dr-smile/foundations/breakpoints.ts
var breakpoints4 = {
  base: "0em",
  tablet: "1024px",
  desktop: "1366px",
  desktopXL: "1600px"
};

// src/dr-smile/foundations/space.ts
var space3 = {
  0: "0px",
  0.25: "2px",
  0.5: "4px",
  0.75: "6px",
  1: "8px",
  1.25: "10px",
  1.5: "12px",
  1.75: "14px",
  2: "16px",
  2.5: "20px",
  3: "24px",
  3.5: "28px",
  4: "32px",
  4.5: "36px",
  5: "40px",
  5.5: "44px",
  6: "48px",
  6.5: "52px",
  7: "56px",
  8: "64px",
  10: "80px",
  12: "96px",
  20: "160px"
};

// src/dr-smile/foundations/colors.ts
var colors5 = {
  base: {
    primary: "hsla(0, 0%, 100%, 1)",
    secondary: "hsla(0, 0%, 96%, 1)",
    overlay: "  hsla(0, 0%, 0%, 0.35)",
    overlayInverse: "hsla(0, 0%, 0%, 0.9)",
    accent: "hsla(219, 89%, 55%, 1)",
    primaryInverse: "hsla(0, 0%, 3%, 1)",
    secondaryInverse: "hsla(0, 0%, 16%, 1)",
    surface: "hsla(0, 0%, 100%, 0.7)",
    surfaceInverse: "hsla(0, 0%, 12%, 0.7)",
    surfacePrimary: "rgba(255, 255, 255, 0.7)",
    surfaceSecondary: "rgba(242, 242, 242, 0.5)",
    accentGradient: "linear-gradient(90deg, hsla(1, 100%, 75%, 1), hsla(1, 80%, 59%, 1))",
    transparent: "hsla(0, 0%, 0%, 0)",
    dashboard: "hsla(44, 50%, 94%, 1)",
    gradient: "linear-gradient(91.25deg, #FFFBEF 9.36%, #FDEFEF 68.08%)",
    gradient2: "linear-gradient(91.25deg, hsla(44, 100%, 97%, 1), hsla(0, 78%, 96%, 1))",
    logo: "hsla(230, 80%, 52%, 1)",
    autofill: "transparent"
  },
  action: {
    primary1: "hsla(219, 89%, 55%, 1)",
    primary1Inverse: "hsla(0, 0%, 100%, 1)",
    primary2: "hsla(220, 96%, 45%, 1)",
    primary2Inverse: "hsla(220, 96%, 60%, 1)",
    primary1Press: "hsla(359, 70%, 47%, 1)",
    primaryBitterSweet: "hsla(359, 88%, 55%, 1)",
    secondary: "hsla(0, 0%, 100%, 1)",
    tertiary: "hsla(0, 0%, 0%, 0.04)",
    tertiaryInverse: "hsla(0, 0%, 94%, 0.6)",
    tertiaryPress: "hsla(0, 0%, 0%, 0.08)",
    surface: "hsla(0, 0%, 100%, 0.6)",
    surfaceInverse: "hsla(0, 0%, 100%, 0.3)",
    attention: "hsla(31, 95%, 56%, 1)",
    success: "hsla(130, 53%, 58%, 1)",
    disabled: "hsla(0, 0%, 0%, 0.03)",
    input: "hsla(216, 14%, 93%, 1)",
    error: "hsla(349, 92%, 48%, 1)",
    hover: "#175EE2",
    tinted: "hsla(219, 89%, 55%, 1)"
  },
  elevation: {
    low: "hsla(0, 0%, 0%, 0.09)",
    medium: "hsla(0, 0%, 0%, 0.12)",
    high: "hsla(0, 0%, 0%, 0.2)",
    mediumPrimary: "hsla(1, 78%, 64%, 0.3)",
    mediumPrimary2: "hsla(234, 78%, 64%, 0.3)",
    mediumAttention: "hsla(31, 78%, 64%, 0.3)",
    mediumSuccess: "hsla(130, 78%, 64%, 0.3)"
  },
  text: {
    primary: "hsla(207, 14%, 18%, 1)",
    primaryInverse: "hsla(0, 0%, 100%, 1)",
    primaryContrast: "hsla(207, 14%, 18%, 1)",
    primaryContrastInverse: "hsla(0, 0%, 100%, 1)",
    secondary: "hsla(190, 3%, 34%, 0.6)",
    secondaryInverse: "hsla(207, 100%, 100%, 0.7)",
    secondaryContrast: "hsla(190, 3%, 34%, 0.6)",
    secondaryContrastInverse: "hsla(207, 100%, 100%, 0.7)",
    tertiary: "hsla(207, 14%, 9%, 0.22)",
    tertiaryInverse: "hsla(0, 0%, 100%, 0.4)",
    tertiaryContrast: "hsla(207, 14%, 9%, 0.22)",
    tertiaryContrastInverse: "hsla(0, 0%, 100%, 0.4)",
    placeholder: "hsla(190, 3%, 75%, 0.6)",
    accent: "hsla(219, 89%, 55%, 1)",
    accentInverse: "hsla(219, 89%, 55%, 1)",
    link: "hsla(234, 100%, 50%, 1)",
    linkInverse: "hsla(234, 100%, 50%, 1)",
    disabled: "hsla(190, 5%, 74%, 0.4)",
    disabledInverse: "hsla(190, 5%, 74%, 0.4)",
    disabledContrast: "hsla(190, 5%, 74%, 0.4)",
    disabledContrastInverse: "hsla(190, 5%, 74%, 0.4)"
  },
  line: {
    primary: "hsla(219, 89%, 55%, 1)",
    secondary: "hsla(207, 14%, 30%, 0.1)",
    primaryInverse: "hsla(0, 0%, 100%, 1)",
    secondaryInverse: "hsla(0, 0%, 100%, 0.3)"
  },
  brand: {
    cultured: "hsla(190, 21%, 95%, 1)",
    lavendar: "hsla(0, 78%, 96%, 1)",
    charcoal: "hsla(207, 14%, 30%, 1)",
    honey: "hsla(42, 100%, 50%, 1)"
  },
  tint: {
    success: "hsla(130, 53%, 58%, 1)",
    attention: "hsla(31, 95%, 56%, 1)"
  }
};

// src/dr-smile/foundations/fonts.ts
var fonts4 = {
  body: `'Inter', sans-serif`,
  heading: `'Inter', sans-serif`
};

// src/dr-smile/foundations/sizes.ts
var sizes12 = {
  0.5: "4px",
  1: "8px",
  1.5: "12px",
  2: "16px",
  2.5: "20px",
  3: "24px",
  3.5: "28px",
  4: "32px",
  4.5: "36px",
  5: "40px",
  5.5: "44px",
  6: "48px",
  6.5: "52px",
  7: "56px",
  8: "64px",
  8.5: "68px",
  10: "80px",
  12: "96px",
  17.5: "140px",
  18: "144px",
  25: "200px",
  26: "208px",
  32.5: "260px",
  42: "336px"
};

// src/dr-smile/foundations/fontSizes.ts
var fontSizes4 = {
  11: "11px",
  13: "13px",
  15: "15px",
  17: "17px",
  20: "20px",
  22: "22px",
  28: "28px",
  35: "35px",
  40: "40px",
  45: "45px",
  50: "50px",
  64: "64px",
  96: "96px",
  144: "142px",
  240: "240px"
};

// src/dr-smile/foundations/fontWeights.ts
var fontWeights4 = {
  body: 400,
  heading: 600,
  bold: 600
};

// src/dr-smile/foundations/lineHeights.ts
var lineHeights3 = {
  normal: "normal",
  inherit: "inherit",
  base: "140%",
  heading: "120%",
  2: "16px",
  3: "24px",
  5: "40px"
};

// src/dr-smile/foundations/textStyles.ts
var textStyles4 = {
  display1: {
    fontSize: [45, 45, 64],
    lineHeight: "100%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  display2: {
    fontSize: [40, 40, 50],
    lineHeight: "100%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  title1: {
    fontSize: [28, 28, 35],
    lineHeight: "120%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  title2: {
    fontSize: [22, 22, 28],
    fontWeight: "heading",
    lineHeight: "120%",
    letterSpacing: "-0.02em"
  },
  title3: {
    fontSize: [17, 17, 20],
    fontWeight: "heading",
    lineHeight: "120%",
    letterSpacing: "0em"
  },
  title4: {
    fontSize: [13, 13, 17],
    lineHeight: "120%",
    fontWeight: "heading",
    letterSpacing: "0.04em",
    textTransform: "uppercase"
  },
  body: {
    fontSize: [17, 17, 20],
    lineHeight: "140%"
  },
  caption: {
    fontSize: [13, 13, 17],
    lineHeight: "140%"
  },
  captionSmall: {
    fontSize: [11, 11, 15],
    lineHeight: "140%"
  },
  action: {
    fontSize: [17, 17, 20],
    lineHeight: "120%",
    fontWeight: "bold"
  }
};

// src/dr-smile/foundations/radii.ts
var radii4 = {
  none: "0",
  base: "8px",
  xs: "2px",
  sm: "4px",
  md: "8px",
  lg: "16px",
  xl: "20px"
};

// src/dr-smile/foundations/zIndices.ts
var zIndices4 = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 20,
  sticky: 30,
  banner: 40,
  overlay: 50,
  modal: 60,
  popover: 70,
  skipLink: 80,
  toast: 90,
  tooltip: 100
};

// src/dr-smile/foundations/shadows.ts
var shadows4 = {
  low: "0px 1px 10px 0px rgba(0, 0, 0, 0.09)",
  medium: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
  mediumPrimary: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
  mediumPrimaryInverse: "0px 4px 12px rgba(0, 0, 0, 0.12)",
  mediumPrimary2: "0px 4px 12px 0px rgba(91, 105, 235, 0.3)",
  mediumSuccess: "0px 4px 12px 0px rgba(91, 235, 115, 0.3)",
  mediumAttention: "0px 4px 12px 0px rgba(235, 165, 91, 0.3)",
  high: "0px 10px 40px rgba(0, 0, 0, 0.2)",
  box: {
    base: "0px 0px 0px 1px hsla(207, 14%, 30%, 0.1)",
    selected: "0px 0px 0px 2px hsla(1, 78%, 64%, 1)"
  }
};

// src/dr-smile/components/Input.ts
var baseStyle20 = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    color: "text.primary",
    ".chakra-input__left-element ~ &": {
      pl: 4.5
    },
    ".chakra-input__right-element ~ &": {
      pr: 4.5
    }
  },
  element: {
    boxSizing: "content-box",
    width: 3
  }
};
var variantFlushed3 = {
  field: {
    width: "100%",
    borderBottom: "1px solid",
    borderColor: "line.secondary",
    borderRadius: 0,
    px: 0,
    bg: "transparent",
    _readOnly: {
      boxShadow: "none !important",
      userSelect: "all"
    },
    _focus: {
      borderColor: "text.link"
    },
    _invalid: {
      borderColor: "action.error"
    },
    _placeholder: {
      transition: "all 0.3s"
    }
  },
  addon: {
    borderBottom: "1px solid",
    borderColor: "inherit",
    borderRadius: 0,
    px: 0,
    bg: "transparent"
  }
};
var sizes13 = {
  md: {
    field: {
      h: [7, 7, 5.5],
      ...textStyles4.body
    },
    addon: {
      h: [7, 7, 5.5],
      ...textStyles4.body
    }
  }
};
var Input4 = {
  parts: parts20.keys,
  baseStyle: baseStyle20,
  sizes: sizes13,
  variants: {
    flushed: variantFlushed3
  },
  defaultProps: {
    size: "md",
    variant: "flushed"
  }
};

// src/dr-smile/components/Radio.ts
var Radio4 = {
  baseStyle: {
    label: {
      userSelect: "none",
      _disabled: { opacity: 0.4 }
    },
    control: {
      w: "100%",
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      color: "base.secondary",
      bg: "text.placeholder",
      borderRadius: "50%",
      _checked: {
        bg: "base.accent",
        _before: {
          content: '""',
          display: "inline-block",
          pos: "relative",
          w: 1,
          h: 1,
          borderRadius: "50%",
          bg: "base.primary"
        }
      },
      _disabled: {
        _hover: {
          cursor: "not-allowed",
          borderColor: "base.secondary"
        }
      }
    }
  },
  sizes: {
    md: {
      control: { w: 3, h: 3 }
    }
  },
  defaultProps: {
    size: "md",
    colorScheme: "base.checkbox"
  }
};

// src/dr-smile/components/Skeleton.ts
import { keyframes as keyframes4 } from "@emotion/react";
var fade4 = () => keyframes4({
  from: { opacity: 1 },
  to: { opacity: 0.4 }
});
var Skeleton4 = {
  sizes: {
    sm: { w: [4.5, 8.5], h: [3, 3.5] },
    md: { w: [17.5, 32.5], h: [3, 3.5] },
    lg: { w: [26, 42], h: [4.5, 5.5] }
  },
  baseStyle: {
    borderRadius: "xs",
    borderColor: "base.secondary",
    background: "base.secondary",
    animation: `0.8s linear infinite alternate ${fade4()}`
  },
  defaultProps: {
    size: "md"
  }
};

// src/dr-smile/components/Spinner.ts
var Spinner4 = {
  sizes: {
    md: { w: 2.5, h: 2.5 }
  },
  defaultProps: {
    size: "md"
  }
};

// src/dr-smile/components/Heading.ts
var Heading4 = {
  baseStyle: {
    textStyle: "display1",
    color: "text.primary"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/dr-smile/components/Text.ts
var Text4 = {
  variants: {
    base: {
      textStyle: "body",
      color: "text.primary"
    },
    unstyled: {}
  },
  defaultProps: {
    variant: "base"
  }
};

// src/dr-smile/components/Checkbox.ts
var Checkbox4 = {
  baseStyle: {
    control: {
      outline: "none"
    },
    label: {
      userSelect: "none"
    }
  },
  sizes: {
    sm: {
      icon: { h: "10px" },
      control: { w: 2.5, h: 2.5 }
    },
    md: {
      icon: { h: "10px" },
      control: { w: 3, h: 3 }
    }
  },
  variants: {
    primary: {
      icon: {
        color: "text.primaryInverse"
      },
      container: {
        w: "100%",
        flexDirection: "row-reverse",
        justifyContent: "space-between"
      },
      control: {
        border: "1px solid",
        borderColor: "text.primary",
        borderRadius: "2px",
        bg: "text.primaryInverse",
        "& > svg": {
          display: "none",
          color: "text.primaryInverse"
        },
        _checked: {
          bg: "action.primary1",
          borderColor: "action.primary1",
          _hover: {
            bg: "action.primary1",
            borderColor: "action.primary1"
          },
          "& > svg": {
            display: "block"
          }
        },
        _focus: {
          boxShadow: "none"
        },
        _hover: {
          borderColor: "action.primary1"
        }
      },
      label: {
        ...textStyles4.body,
        ml: 0,
        mr: 2
      }
    },
    secondary: {
      icon: {
        color: "text.primaryInverse"
      },
      container: {
        w: "100%",
        flexDirection: "row-reverse",
        justifyContent: "space-between"
      },
      control: {
        border: "none",
        borderRadius: "sm",
        bg: "text.placeholder",
        _checked: {
          bg: "action.primary1",
          _hover: {
            bg: "action.primary1"
          }
        },
        _focus: {
          boxShadow: "none"
        }
      },
      label: {
        ...textStyles4.caption,
        ml: 0,
        mr: 2
      }
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/dr-smile/components/Tabs.ts
var Tabs4 = {
  parts: ["root", "tab", "tablist"],
  baseStyle: {
    tab: {
      h: ["36px", 7],
      color: "text.primary",
      border: "1px solid",
      borderColor: "line.secondary",
      borderRadius: "xl",
      px: 2,
      py: [1, 2],
      textStyle: "action",
      _hover: {
        bg: "base.surfaceSecondary",
        color: "text.primary",
        cursor: "pointer",
        borderColor: "line.secondary"
      },
      _selected: {
        color: "text.primaryInverse",
        bg: "base.primaryInverse",
        borderColor: "base.primaryInverse"
      }
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/dr-smile/components/Alert.ts
var parts21 = ["container", "icon", "title", "description", "spinner"];
var baseStyle21 = {
  container: {
    p: 3,
    display: "flex"
  },
  title: {
    fontWeight: "bold",
    textStyle: "title2",
    mb: 1
  },
  description: {
    textStyle: "body"
  },
  icon: {
    flexShrink: 0,
    marginEnd: 1,
    w: "20px",
    h: "20px"
  }
};
var variantLeftAccent4 = () => {
  return {
    container: {
      borderColor: "base.overlay",
      borderWidth: "1px",
      borderRadius: "md",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    title: {
      color: "text.secondary"
    },
    icon: {},
    description: {
      color: "text.secondary"
    }
  };
};
var variantTopAccent4 = () => {
  return {
    container: {
      flexDirection: "column"
    },
    icon: {},
    description: {}
  };
};
var variants9 = {
  "left-accent": variantLeftAccent4,
  "top-accent": variantTopAccent4
};
var defaultProps8 = {
  variant: "left-accent"
};
var Alert4 = {
  parts: parts21,
  baseStyle: baseStyle21,
  variants: variants9,
  defaultProps: defaultProps8
};

// src/dr-smile/components/Link.ts
var Link4 = {
  baseStyle: {
    color: "text.primary"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/dr-smile/components/Tag.ts
var Tag4 = {
  parts: ["container"],
  baseStyle: {
    container: {
      px: 1,
      py: 0.5,
      textStyle: ["title3", "title3", "title1"],
      textTransform: "uppercase",
      borderRadius: "xs"
    }
  },
  variants: {
    base: {
      container: {
        color: "text.primary",
        px: 0
      }
    },
    primary: {
      container: {
        backgroundColor: "base.primaryInverse",
        color: "text.primaryInverse"
      }
    },
    accent: {
      container: {
        backgroundColor: "base.accent",
        color: "text.primaryInverse"
      }
    }
  },
  defaultProps: {
    variant: "base"
  }
};

// src/dr-smile/components/Divider.ts
var Divider4 = {
  baseStyle: {
    borderWidth: ["1px", "1px", "2px"],
    borderColor: "line.secondary",
    borderStyle: "solid"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/dr-smile/components/Menu.ts
import { theme as theme5 } from "@chakra-ui/react";
var Menu4 = theme5.components.Menu;

// src/dr-smile/styles.ts
var styles_exports3 = {};
__export(styles_exports3, {
  styles: () => styles5
});
var styles5 = {
  global: {
    body: {
      fontFamily: "body"
    },
    "html, body": {
      background: "base.primary"
    },
    em: {
      color: "text.accent",
      fontStyle: "normal"
    },
    mark: {
      color: "text.link",
      fontStyle: "normal",
      backgroundColor: "unset"
    },
    a: {
      color: "text.link"
    }
  }
};

// src/dr-smile/index.ts
var DrSmileTheme = {
  config: {
    initialColorMode: "light"
  },
  direction: "ltr",
  borders: {},
  letterSpacings: {},
  transition: {
    property: {},
    easing: {},
    duration: {}
  },
  components: components_exports5,
  ...styles_exports3,
  ...foundations_exports5
};

// src/smajla/components/index.ts
var components_exports6 = {};
__export(components_exports6, {
  Alert: () => Alert5,
  Button: () => Button6,
  Checkbox: () => Checkbox5,
  Container: () => Container5,
  Divider: () => Divider5,
  Drawer: () => Drawer5,
  Form: () => Form5,
  FormError: () => FormError5,
  FormLabel: () => FormLabel5,
  Heading: () => Heading5,
  Icon: () => Icon5,
  Input: () => Input5,
  Link: () => Link5,
  Menu: () => Menu5,
  Radio: () => Radio5,
  Skeleton: () => Skeleton5,
  Spinner: () => Spinner5,
  Tabs: () => Tabs5,
  Tag: () => Tag5,
  Text: () => Text5
});

// src/smajla/components/Button.ts
var getHoverAndFocusStyles6 = (styles7) => ({
  _hover: styles7,
  _focus: styles7
});
var Button6 = {
  baseStyle: {
    cursor: "pointer",
    textStyle: "action"
  },
  sizes: {
    sm: {
      h: [4, 4, 4.5],
      px: 1,
      borderRadius: "sm"
    },
    md: {
      py: 2,
      px: [3, 3, 5],
      borderRadius: "md",
      minWidth: 18
    },
    lg: {
      py: 2,
      px: [3, 3, 5],
      borderRadius: "md",
      minWidth: 18
    }
  },
  variants: {
    primary: {
      color: "text.primaryInverse",
      bg: "action.primary1",
      boxShadow: "mediumPrimary",
      ...getHoverAndFocusStyles6({
        bg: "action.primary1Press"
      }),
      _disabled: {
        cursor: "default"
      }
    },
    secondary: {
      color: "text.primary",
      bg: "action.tertiary",
      ...getHoverAndFocusStyles6({
        bg: "action.tertiaryPress"
      }),
      _disabled: {
        cursor: "default",
        bg: "action.tertiary"
      }
    },
    surface: {
      color: "text.primary",
      bg: "action.surface"
    },
    surfaceInverse: {
      color: "text.primaryInverse",
      bg: "action.surfaceInverse"
    },
    ghost: {
      color: "text.accent",
      ...getHoverAndFocusStyles6({
        color: "elevation.mediumPrimary"
      })
    },
    primaryInverse: {
      color: "text.primary",
      bg: "action.primary1Inverse",
      boxShadow: "mediumPrimaryInverse"
    },
    primary2: {
      color: "text.primaryInverse",
      bg: "action.primary2",
      ...getHoverAndFocusStyles6({
        bg: "action.primary2Inverse"
      })
    },
    attention: {
      color: "text.primaryInverse",
      bg: "action.attention",
      ...getHoverAndFocusStyles6({
        bg: "elevation.mediumAttention"
      })
    },
    success: {
      color: "text.primaryInverse",
      bgColor: "action.success",
      ...getHoverAndFocusStyles6({
        bg: "elevation.mediumSuccess"
      })
    },
    disabled: {
      color: "text.primaryInverse",
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    }
  },
  defaultProps: {
    size: "md",
    variant: "primary"
  }
};

// src/smajla/components/Container.ts
var spacingStyles4 = {
  xs: {
    mb: [3, 3, 5]
  },
  sm: {
    mb: [5, 5, 10]
  },
  md: {
    mb: [10, 10, 20]
  },
  none: {}
};
var Container5 = {
  baseStyle: ({ spacing }) => ({
    maxW: ["480px", "604px", "1208px"],
    w: "100%",
    mx: "auto",
    ...spacingStyles4[spacing === "default" ? "md" : spacing]
  }),
  variants: {
    base: {
      px: [3, 5, 0]
    }
  },
  defaultProps: {
    spacing: "none"
  }
};

// src/smajla/components/Drawer.ts
import { drawerAnatomy as parts22 } from "@chakra-ui/anatomy";
function getSize6(value) {
  if (value === "full") {
    return {
      dialog: { maxW: "100vw", h: "100vh" }
    };
  }
  return {
    dialog: { maxW: value }
  };
}
var baseStyleOverlay6 = {
  bg: "base.overlay",
  zIndex: "overlay"
};
var baseStyleDialogContainer6 = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
};
var baseStyleDialog6 = (props) => {
  const { isFullHeight, rounded, borderRadius = "xl", position } = props;
  return {
    ...isFullHeight && { height: "100vh" },
    ...rounded && {
      overflow: "hidden",
      ...position === "left" && {
        borderRightRadius: borderRadius
      },
      ...position === "right" && {
        borderLeftRadius: borderRadius
      },
      ...position === "top" && {
        borderBottomRadius: borderRadius
      },
      ...position === "bottom" && {
        borderTopRadius: borderRadius
      }
    },
    zIndex: "modal",
    bg: "base.primary",
    color: "inherit"
  };
};
var baseStyleHeader6 = {
  p: 3
};
var baseStyleCloseButton6 = {
  position: "absolute",
  top: 2,
  insetEnd: 3,
  marginLeft: "auto"
};
var baseStyleBody6 = {
  p: 3,
  flex: 1,
  overflow: "auto"
};
var baseStyleFooter6 = {
  p: 3
};
var baseStyle22 = (props) => ({
  overlay: baseStyleOverlay6,
  dialogContainer: baseStyleDialogContainer6,
  dialog: baseStyleDialog6(props),
  header: baseStyleHeader6,
  closeButton: baseStyleCloseButton6,
  body: baseStyleBody6,
  footer: baseStyleFooter6
});
var sizes14 = {
  xs: getSize6("25%"),
  sm: getSize6("35%"),
  md: getSize6("50%"),
  lg: getSize6("75%"),
  xl: getSize6("90%"),
  full: getSize6("full")
};
var variants10 = {
  mobileMd: {
    dialog: {
      height: "55%",
      borderTopRadius: "lg"
    }
  },
  mobileXl: {
    dialog: {
      height: "98%",
      borderTopRadius: "lg"
    }
  }
};
var defaultProps9 = {
  size: "md"
};
var Drawer5 = {
  parts: parts22.keys,
  baseStyle: baseStyle22,
  sizes: sizes14,
  variants: variants10,
  defaultProps: defaultProps9
};

// src/smajla/components/Form.ts
import { formAnatomy as parts23 } from "@chakra-ui/anatomy";
var floatingLabelStyles5 = {
  initial: {
    top: ["18px", "18px", 3],
    left: 0,
    zIndex: 2,
    position: "absolute",
    backgroundColor: "transparent",
    pointerEvents: "none",
    color: "text.primary"
  },
  floating: {
    transform: "translateY(-100%)",
    color: "text.secondary",
    textStyle: "caption"
  },
  offsetStart: {
    left: 4.5
  }
};
var baseStyle23 = {
  container: {
    width: "100%",
    position: "relative"
  },
  helperText: {
    textStyle: "caption",
    color: "text.secondary",
    mt: 0.5
  }
};
var Form5 = {
  parts: parts23.keys,
  baseStyle: baseStyle23,
  variants: {
    floating: {
      container: {
        pt: [0.25, 0.25, 2],
        _focusWithin: {
          ".chakra-form__label": { ...floatingLabelStyles5.floating }
        },
        ".chakra-input__group": { position: "static" },
        "input:not(:placeholder-shown) + .chakra-form__label, .chakra-select__wrapper + .chakra-form__label, .chakra-react-select--has-value + .chakra-form__label": { ...floatingLabelStyles5.floating },
        ".chakra-form__label": { ...floatingLabelStyles5.initial },
        ".chakra-input__left-element ~ .chakra-form__label, .chakra-react-select--has-icon-left ~ .chakra-form__label": { ...floatingLabelStyles5.offsetStart }
      }
    }
  }
};

// src/smajla/components/FormLabel.ts
var FormLabel5 = {
  baseStyle: {
    marginEnd: 3,
    mb: 2,
    transition: "color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    opacity: 1,
    _disabled: {
      opacity: 0.4
    },
    textStyle: "body",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
};

// src/smajla/components/FormError.ts
import { formErrorAnatomy as parts24 } from "@chakra-ui/anatomy";
var baseStyleText5 = {
  color: "action.error",
  mt: 0.5,
  textStyle: "caption"
};
var baseStyleIcon5 = {
  marginEnd: 0.5,
  color: "action.error"
};
var baseStyle24 = {
  text: baseStyleText5,
  icon: baseStyleIcon5
};
var FormError5 = {
  parts: parts24.keys,
  baseStyle: baseStyle24
};

// src/smajla/components/Icon.ts
var Icon5 = {
  baseStyle: {
    color: "text.primary",
    display: "inline"
  },
  sizes: {
    sm: {
      w: 2,
      h: 2
    },
    md: {
      w: 3,
      h: 3
    },
    lg: {
      w: 6,
      h: 6
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/smajla/components/Input.ts
import { inputAnatomy as parts25 } from "@chakra-ui/anatomy";

// src/smajla/foundations/index.ts
var foundations_exports6 = {};
__export(foundations_exports6, {
  breakpoints: () => breakpoints5,
  colors: () => colors6,
  fontSizes: () => fontSizes5,
  fontWeights: () => fontWeights5,
  fonts: () => fonts5,
  lineHeights: () => lineHeights4,
  radii: () => radii5,
  shadows: () => shadows5,
  sizes: () => sizes15,
  space: () => space4,
  textStyles: () => textStyles5,
  zIndices: () => zIndices5
});

// src/smajla/foundations/breakpoints.ts
var breakpoints5 = {
  base: "0em",
  tablet: "1024px",
  desktop: "1366px",
  desktopXL: "1600px"
};

// src/smajla/foundations/space.ts
var space4 = {
  0: "0px",
  0.25: "2px",
  0.5: "4px",
  0.75: "6px",
  1: "8px",
  1.25: "10px",
  1.5: "12px",
  1.75: "14px",
  2: "16px",
  2.5: "20px",
  3: "24px",
  3.5: "28px",
  4: "32px",
  4.5: "36px",
  5: "40px",
  5.5: "44px",
  6: "48px",
  6.5: "52px",
  7: "56px",
  8: "64px",
  10: "80px",
  12: "96px",
  20: "160px"
};

// src/smajla/foundations/colors.ts
var colors6 = {
  base: {
    primary: "hsla(0, 0%, 100%, 1)",
    secondary: "hsla(0, 0%, 96%, 1)",
    overlay: "  hsla(0, 0%, 0%, 0.35)",
    overlayInverse: "hsla(0, 0%, 0%, 0.9)",
    accent: "hsla(219, 89%, 55%, 1)",
    primaryInverse: "hsla(0, 0%, 3%, 1)",
    secondaryInverse: "hsla(0, 0%, 16%, 1)",
    surface: "hsla(0, 0%, 100%, 0.7)",
    surfaceInverse: "hsla(0, 0%, 12%, 0.7)",
    surfacePrimary: "rgba(255, 255, 255, 0.7)",
    surfaceSecondary: "rgba(242, 242, 242, 0.5)",
    accentGradient: "linear-gradient(90deg, hsla(1, 100%, 75%, 1), hsla(1, 80%, 59%, 1))",
    transparent: "hsla(0, 0%, 0%, 0)",
    dashboard: "hsla(44, 50%, 94%, 1)",
    gradient: "linear-gradient(91.25deg, #FFFBEF 9.36%, #FDEFEF 68.08%)",
    gradient2: "linear-gradient(91.25deg, hsla(44, 100%, 97%, 1), hsla(0, 78%, 96%, 1))",
    logo: "hsla(230, 80%, 52%, 1)",
    autofill: "transparent",
    stoneGray: "hsla(191, 9%, 46%, 1)",
    logoPink: " hsla(0, 43%, 66%, 1)"
  },
  action: {
    primary1: "hsla(0, 42%, 66%, 1)",
    primary1Inverse: "hsla(0, 0%, 100%, 1)",
    primary2: "hsla(220, 96%, 45%, 1)",
    primary2Inverse: "hsla(220, 96%, 60%, 1)",
    primary1Press: "hsla(359, 70%, 47%, 1)",
    primaryBitterSweet: "hsla(359, 88%, 55%, 1)",
    secondary: "hsla(0, 0%, 100%, 1)",
    tertiary: "hsla(0, 0%, 0%, 0.04)",
    tertiaryInverse: "hsla(0, 0%, 94%, 0.6)",
    tertiaryPress: "hsla(0, 0%, 0%, 0.08)",
    surface: "hsla(0, 0%, 100%, 0.6)",
    surfaceInverse: "hsla(0, 0%, 100%, 0.3)",
    attention: "hsla(31, 95%, 56%, 1)",
    success: "hsla(130, 53%, 58%, 1)",
    disabled: "hsla(0, 0%, 0%, 0.03)",
    input: "hsla(216, 14%, 93%, 1)",
    error: "hsla(349, 92%, 48%, 1)",
    hover: "#175EE2",
    tinted: "hsla(219, 89%, 55%, 1)"
  },
  elevation: {
    low: "hsla(0, 0%, 0%, 0.09)",
    medium: "hsla(0, 0%, 0%, 0.12)",
    high: "hsla(0, 0%, 0%, 0.2)",
    mediumPrimary: "hsla(1, 78%, 64%, 0.3)",
    mediumPrimary2: "hsla(234, 78%, 64%, 0.3)",
    mediumAttention: "hsla(31, 78%, 64%, 0.3)",
    mediumSuccess: "hsla(130, 78%, 64%, 0.3)"
  },
  text: {
    primary: "hsla(207, 14%, 18%, 1)",
    primaryInverse: "hsla(0, 0%, 100%, 1)",
    primaryContrast: "hsla(207, 14%, 18%, 1)",
    primaryContrastInverse: "hsla(0, 0%, 100%, 1)",
    secondary: "hsla(190, 3%, 34%, 0.6)",
    secondaryInverse: "hsla(207, 100%, 100%, 0.7)",
    secondaryContrast: "hsla(190, 3%, 34%, 0.6)",
    secondaryContrastInverse: "hsla(207, 100%, 100%, 0.7)",
    tertiary: "hsla(207, 14%, 9%, 0.22)",
    tertiaryInverse: "hsla(0, 0%, 100%, 0.4)",
    tertiaryContrast: "hsla(207, 14%, 9%, 0.22)",
    tertiaryContrastInverse: "hsla(0, 0%, 100%, 0.4)",
    placeholder: "hsla(190, 3%, 75%, 0.6)",
    accent: "hsla(219, 89%, 55%, 1)",
    accentInverse: "hsla(219, 89%, 55%, 1)",
    link: "hsla(234, 100%, 50%, 1)",
    linkInverse: "hsla(234, 100%, 50%, 1)",
    disabled: "hsla(190, 5%, 74%, 0.4)",
    disabledInverse: "hsla(190, 5%, 74%, 0.4)",
    disabledContrast: "hsla(190, 5%, 74%, 0.4)",
    disabledContrastInverse: "hsla(190, 5%, 74%, 0.4)"
  },
  line: {
    primary: "hsla(219, 89%, 55%, 1)",
    secondary: "hsla(207, 14%, 30%, 0.1)",
    primaryInverse: "hsla(0, 0%, 100%, 1)",
    secondaryInverse: "hsla(0, 0%, 100%, 0.3)"
  },
  brand: {
    cultured: "hsla(190, 21%, 95%, 1)",
    lavendar: "hsla(0, 78%, 96%, 1)",
    charcoal: "hsla(207, 14%, 30%, 1)",
    honey: "hsla(42, 100%, 50%, 1)"
  },
  tint: {
    success: "hsla(130, 53%, 58%, 1)",
    attention: "hsla(31, 95%, 56%, 1)"
  }
};

// src/smajla/foundations/fonts.ts
var fonts5 = {
  body: `'Inter', sans-serif`,
  heading: `'Inter', sans-serif`
};

// src/smajla/foundations/sizes.ts
var sizes15 = {
  0.5: "4px",
  1: "8px",
  1.5: "12px",
  2: "16px",
  2.5: "20px",
  3: "24px",
  3.5: "28px",
  4: "32px",
  4.5: "36px",
  5: "40px",
  5.5: "44px",
  6: "48px",
  6.5: "52px",
  7: "56px",
  8: "64px",
  8.5: "68px",
  10: "80px",
  12: "96px",
  17.5: "140px",
  18: "144px",
  25: "200px",
  26: "208px",
  32.5: "260px",
  42: "336px"
};

// src/smajla/foundations/fontSizes.ts
var fontSizes5 = {
  11: "11px",
  13: "13px",
  15: "15px",
  17: "17px",
  20: "20px",
  22: "22px",
  28: "28px",
  35: "35px",
  40: "40px",
  45: "45px",
  50: "50px",
  64: "64px",
  96: "96px",
  144: "142px",
  240: "240px"
};

// src/smajla/foundations/fontWeights.ts
var fontWeights5 = {
  body: 400,
  heading: 600,
  bold: 600
};

// src/smajla/foundations/lineHeights.ts
var lineHeights4 = {
  normal: "normal",
  inherit: "inherit",
  base: "140%",
  heading: "120%",
  2: "16px",
  3: "24px",
  5: "40px"
};

// src/smajla/foundations/textStyles.ts
var textStyles5 = {
  display1: {
    fontSize: [45, 45, 64],
    lineHeight: "100%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  display2: {
    fontSize: [40, 40, 50],
    lineHeight: "100%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  title1: {
    fontSize: [28, 28, 35],
    lineHeight: "120%",
    fontWeight: "heading",
    letterSpacing: "-0.02em"
  },
  title2: {
    fontSize: [22, 22, 28],
    fontWeight: "heading",
    lineHeight: "120%",
    letterSpacing: "-0.02em"
  },
  title3: {
    fontSize: [17, 17, 20],
    fontWeight: "heading",
    lineHeight: "120%",
    letterSpacing: "0em"
  },
  title4: {
    fontSize: [13, 13, 17],
    lineHeight: "120%",
    fontWeight: "heading",
    letterSpacing: "0.04em",
    textTransform: "uppercase"
  },
  body: {
    fontSize: [17, 17, 20],
    lineHeight: "140%"
  },
  caption: {
    fontSize: [13, 13, 17],
    lineHeight: "140%"
  },
  captionSmall: {
    fontSize: [11, 11, 15],
    lineHeight: "140%"
  },
  action: {
    fontSize: [17, 17, 20],
    lineHeight: "120%",
    fontWeight: "bold"
  }
};

// src/smajla/foundations/radii.ts
var radii5 = {
  none: "0",
  base: "8px",
  xs: "2px",
  sm: "4px",
  md: "8px",
  lg: "16px",
  xl: "20px"
};

// src/smajla/foundations/zIndices.ts
var zIndices5 = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 20,
  sticky: 30,
  banner: 40,
  overlay: 50,
  modal: 60,
  popover: 70,
  skipLink: 80,
  toast: 90,
  tooltip: 100
};

// src/smajla/foundations/shadows.ts
var shadows5 = {
  low: "0px 1px 10px 0px rgba(0, 0, 0, 0.09)",
  medium: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
  mediumPrimary: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
  mediumPrimaryInverse: "0px 4px 12px rgba(0, 0, 0, 0.12)",
  mediumPrimary2: "0px 4px 12px 0px rgba(91, 105, 235, 0.3)",
  mediumSuccess: "0px 4px 12px 0px rgba(91, 235, 115, 0.3)",
  mediumAttention: "0px 4px 12px 0px rgba(235, 165, 91, 0.3)",
  high: "0px 10px 40px rgba(0, 0, 0, 0.2)",
  box: {
    base: "0px 0px 0px 1px hsla(207, 14%, 30%, 0.1)",
    selected: "0px 0px 0px 2px hsla(1, 78%, 64%, 1)"
  }
};

// src/smajla/components/Input.ts
var baseStyle25 = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    color: "text.primary",
    ".chakra-input__left-element ~ &": {
      pl: 4.5
    },
    ".chakra-input__right-element ~ &": {
      pr: 4.5
    }
  },
  element: {
    boxSizing: "content-box",
    width: 3
  }
};
var variantFlushed4 = {
  field: {
    width: "100%",
    borderBottom: "1px solid",
    borderColor: "line.secondary",
    borderRadius: 0,
    px: 0,
    bg: "transparent",
    _readOnly: {
      boxShadow: "none !important",
      userSelect: "all"
    },
    _focus: {
      borderColor: "text.link"
    },
    _invalid: {
      borderColor: "action.error"
    },
    _placeholder: {
      transition: "all 0.3s"
    }
  },
  addon: {
    borderBottom: "1px solid",
    borderColor: "inherit",
    borderRadius: 0,
    px: 0,
    bg: "transparent"
  }
};
var sizes16 = {
  md: {
    field: {
      h: [7, 7, 5.5],
      ...textStyles5.body
    },
    addon: {
      h: [7, 7, 5.5],
      ...textStyles5.body
    }
  }
};
var Input5 = {
  parts: parts25.keys,
  baseStyle: baseStyle25,
  sizes: sizes16,
  variants: {
    flushed: variantFlushed4
  },
  defaultProps: {
    size: "md",
    variant: "flushed"
  }
};

// src/smajla/components/Radio.ts
var Radio5 = {
  baseStyle: {
    label: {
      userSelect: "none",
      _disabled: { opacity: 0.4 }
    },
    control: {
      w: "100%",
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      color: "base.secondary",
      bg: "text.placeholder",
      borderRadius: "50%",
      _checked: {
        bg: "base.accent",
        _before: {
          content: '""',
          display: "inline-block",
          pos: "relative",
          w: 1,
          h: 1,
          borderRadius: "50%",
          bg: "base.primary"
        }
      },
      _disabled: {
        _hover: {
          cursor: "not-allowed",
          borderColor: "base.secondary"
        }
      }
    }
  },
  sizes: {
    md: {
      control: { w: 3, h: 3 }
    }
  },
  defaultProps: {
    size: "md",
    colorScheme: "base.checkbox"
  }
};

// src/smajla/components/Skeleton.ts
import { keyframes as keyframes5 } from "@emotion/react";
var fade5 = () => keyframes5({
  from: { opacity: 1 },
  to: { opacity: 0.4 }
});
var Skeleton5 = {
  sizes: {
    sm: { w: [4.5, 8.5], h: [3, 3.5] },
    md: { w: [17.5, 32.5], h: [3, 3.5] },
    lg: { w: [26, 42], h: [4.5, 5.5] }
  },
  baseStyle: {
    borderRadius: "xs",
    borderColor: "base.secondary",
    background: "base.secondary",
    animation: `0.8s linear infinite alternate ${fade5()}`
  },
  defaultProps: {
    size: "md"
  }
};

// src/smajla/components/Spinner.ts
var Spinner5 = {
  sizes: {
    md: { w: 2.5, h: 2.5 }
  },
  defaultProps: {
    size: "md"
  }
};

// src/smajla/components/Heading.ts
var Heading5 = {
  baseStyle: {
    textStyle: "display1",
    color: "text.primary"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/smajla/components/Text.ts
var Text5 = {
  variants: {
    base: {
      textStyle: "body",
      color: "text.primary"
    },
    unstyled: {}
  },
  defaultProps: {
    variant: "base"
  }
};

// src/smajla/components/Checkbox.ts
var Checkbox5 = {
  baseStyle: {
    control: {
      outline: "none"
    },
    label: {
      userSelect: "none"
    }
  },
  sizes: {
    sm: {
      icon: { h: "10px" },
      control: { w: 2.5, h: 2.5 }
    },
    md: {
      icon: { h: "10px" },
      control: { w: 3, h: 3 }
    }
  },
  variants: {
    primary: {
      icon: {
        color: "text.primaryInverse"
      },
      container: {
        w: "100%",
        flexDirection: "row-reverse",
        justifyContent: "space-between"
      },
      control: {
        border: "1px solid",
        borderColor: "text.primary",
        borderRadius: "2px",
        bg: "text.primaryInverse",
        "& > svg": {
          display: "none",
          color: "text.primaryInverse"
        },
        _checked: {
          bg: "action.primary1",
          borderColor: "action.primary1",
          _hover: {
            bg: "action.primary1",
            borderColor: "action.primary1"
          },
          "& > svg": {
            display: "block"
          }
        },
        _focus: {
          boxShadow: "none"
        },
        _hover: {
          borderColor: "action.primary1"
        }
      },
      label: {
        ...textStyles5.body,
        ml: 0,
        mr: 2
      }
    },
    secondary: {
      icon: {
        color: "text.primaryInverse"
      },
      container: {
        w: "100%",
        flexDirection: "row-reverse",
        justifyContent: "space-between"
      },
      control: {
        border: "none",
        borderRadius: "sm",
        bg: "text.placeholder",
        _checked: {
          bg: "action.primary1",
          _hover: {
            bg: "action.primary1"
          }
        },
        _focus: {
          boxShadow: "none"
        }
      },
      label: {
        ...textStyles5.caption,
        ml: 0,
        mr: 2
      }
    }
  },
  defaultProps: {
    size: "md"
  }
};

// src/smajla/components/Tabs.ts
var Tabs5 = {
  parts: ["root", "tab", "tablist"],
  baseStyle: {
    tab: {
      h: ["36px", 7],
      color: "text.primary",
      border: "1px solid",
      borderColor: "line.secondary",
      borderRadius: "xl",
      px: 2,
      py: [1, 2],
      textStyle: "action",
      _hover: {
        bg: "base.surfaceSecondary",
        color: "text.primary",
        cursor: "pointer",
        borderColor: "line.secondary"
      },
      _selected: {
        color: "text.primaryInverse",
        bg: "base.primaryInverse",
        borderColor: "base.primaryInverse"
      }
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/smajla/components/Alert.ts
var parts26 = ["container", "icon", "title", "description", "spinner"];
var baseStyle26 = {
  container: {
    p: 3,
    display: "flex"
  },
  title: {
    fontWeight: "bold",
    textStyle: "title2",
    mb: 1
  },
  description: {
    textStyle: "body"
  },
  icon: {
    flexShrink: 0,
    marginEnd: 1,
    w: "20px",
    h: "20px"
  }
};
var variantLeftAccent5 = () => {
  return {
    container: {
      borderColor: "base.overlay",
      borderWidth: "1px",
      borderRadius: "md",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    title: {
      color: "text.secondary"
    },
    icon: {},
    description: {
      color: "text.secondary"
    }
  };
};
var variantTopAccent5 = () => {
  return {
    container: {
      flexDirection: "column"
    },
    icon: {},
    description: {}
  };
};
var variants11 = {
  "left-accent": variantLeftAccent5,
  "top-accent": variantTopAccent5
};
var defaultProps10 = {
  variant: "left-accent"
};
var Alert5 = {
  parts: parts26,
  baseStyle: baseStyle26,
  variants: variants11,
  defaultProps: defaultProps10
};

// src/smajla/components/Link.ts
var Link5 = {
  baseStyle: {
    color: "text.primary"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/smajla/components/Tag.ts
var Tag5 = {
  parts: ["container"],
  baseStyle: {
    container: {
      px: 1,
      py: 0.5,
      textStyle: ["title3", "title3", "title1"],
      textTransform: "uppercase",
      borderRadius: "xs"
    }
  },
  variants: {
    base: {
      container: {
        color: "text.primary",
        px: 0
      }
    },
    primary: {
      container: {
        backgroundColor: "base.primaryInverse",
        color: "text.primaryInverse"
      }
    },
    accent: {
      container: {
        backgroundColor: "base.accent",
        color: "text.primaryInverse"
      }
    }
  },
  defaultProps: {
    variant: "base"
  }
};

// src/smajla/components/Divider.ts
var Divider5 = {
  baseStyle: {
    borderWidth: ["1px", "1px", "2px"],
    borderColor: "line.secondary",
    borderStyle: "solid"
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

// src/smajla/components/Menu.ts
import { theme as theme6 } from "@chakra-ui/react";
var Menu5 = theme6.components.Menu;

// src/smajla/styles.ts
var styles_exports4 = {};
__export(styles_exports4, {
  styles: () => styles6
});
var styles6 = {
  global: {
    body: {
      fontFamily: "body"
    },
    "html, body": {
      background: "base.primary"
    },
    em: {
      color: "text.accent",
      fontStyle: "normal"
    },
    mark: {
      color: "text.link",
      fontStyle: "normal",
      backgroundColor: "unset"
    },
    a: {
      color: "text.link"
    }
  }
};

// src/smajla/index.ts
var SmajlaTheme = {
  config: {
    initialColorMode: "light"
  },
  direction: "ltr",
  borders: {},
  letterSpacings: {},
  transition: {
    property: {},
    easing: {},
    duration: {}
  },
  components: components_exports6,
  ...styles_exports4,
  ...foundations_exports6
};

// src/utils/theme.ts
import { extendTheme as extendThemeBase } from "@chakra-ui/react";
var extendTheme3 = (...themeOverrides) => extendThemeBase(
  ...themeOverrides,
  theme2
);

// src/utils/cssVar.ts
import { cssVar as cssVar2 } from "@chakra-ui/theme-tools";
function tokenToCssVar(token, prefix) {
  return cssVar2(String(token).replace(/\./g, "-"), { prefix });
}
var themeTokenToCssVar = (token, prefix) => tokenToCssVar(token, prefix).reference;

// src/utils/responsive.ts
import {
  isResponsiveObjectLike,
  objectToArrayNotation
} from "@chakra-ui/utils";
var breakpoints6 = Object.keys(breakpoints);
var isResponsiveObject = (responsive, bps = breakpoints6) => responsive && typeof responsive === "object" && isResponsiveObjectLike(responsive, bps);
var mapResponsiveValue = (responsive, mapper, bps = breakpoints6) => {
  if (Array.isArray(responsive)) {
    return responsive.map((element) => element ? mapper(element) : null);
  }
  if (isResponsiveObject(responsive, bps)) {
    return Object.fromEntries(
      Object.entries(responsive).filter((obj) => !!obj[1]).map(([key, value]) => [key, mapper(value)])
    );
  }
  return mapper(responsive);
};
var toResponsiveArray = (responsive, bps = breakpoints6) => {
  if (Array.isArray(responsive)) {
    return responsive;
  }
  if (isResponsiveObject(responsive, bps)) {
    return objectToArrayNotation(responsive);
  }
  return [responsive];
};

// src/utils/customColorModeManager.ts
var customColorModeManager_default = (currentTheme) => {
  return {
    type: "localStorage",
    ssr: false,
    set: (value) => {
      if (typeof window === "undefined") return;
      try {
        localStorage.setItem("chakra-ui-color-mode", value);
      } catch (err) {
        console.error("Failed to save color mode", err);
      }
    },
    get: (init) => {
      return currentTheme?.config?.initialColorMode || init;
    }
  };
};

// src/utils/index.ts
import { useColorMode } from "@chakra-ui/react";
export {
  DrSmileTheme,
  SYTLegacyTheme,
  SYTtheme,
  SYTthemeDark,
  SmajlaTheme,
  customColorModeManager_default as customColorModeManager,
  theme2 as default,
  theme2 as defaultTheme,
  extendTheme3 as extendTheme,
  isResponsiveObject,
  mapResponsiveValue,
  theme2 as theme,
  themeTokenToCssVar,
  toResponsiveArray,
  tokenToCssVar,
  useColorMode
};
